
        <!-- 交易流水 -->
<template>
  <div class="financeSetA">
    <!-- <vue-scroll :ops="ops" style="width:100%;min-height:100%;"> -->
    <!-- <div class="navCalss">| 订单管理</div> -->

    <div class="navCal">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="所有" name="first"></el-tab-pane>
        <el-tab-pane label="国内待入库" name="second"> </el-tab-pane>
        <el-tab-pane label="国内入库" name="third"></el-tab-pane>
        <el-tab-pane label="已合箱" name="6"></el-tab-pane>
        <el-tab-pane label="国内出库" name="four"></el-tab-pane>
        <el-tab-pane label="中心入库" name="7"></el-tab-pane>
        <el-tab-pane label="中心出库" name="8"></el-tab-pane>
        <el-tab-pane label="分舵入库" name="9"></el-tab-pane>
        <el-tab-pane label="客户签收" name="five"></el-tab-pane>
        <el-tab-pane label="已取消" name="six"></el-tab-pane>
        <el-tab-pane label="待补录" name="seven"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="monewt">
      <el-form :inline="true">
        <div style="margin: 10px 0">
          <el-row>
            <el-col>
              <el-form-item label="">
                <el-input
                  v-model="orderNOA"
                  style="width: 150px"
                  placeholder="运单号"
                  @input="inputOrder(orderNOA)"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="orderNOC"
                  @input="realDate(orderNOC)"
                  style="width: 150px"
                  placeholder="用户名/vip号"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="search.goodType"
                  clearable
                  placeholder="货物类型"
                  @change="init()"
                  @clear="init()"
                  style="width: 150px"
                  v-if="activeName !== 'second'"
                >
                  <el-option
                    v-for="item in goodTypeSelect"
                    :key="item.goodType"
                    :label="item.goodName"
                    :value="item.goodType"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="search.addressId"
                  clearable
                  placeholder="派送点"
                  @change="init()"
                  @clear="init()"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in deliveryAddressList"
                    :key="item.addressId"
                    :label="item.deliveryTitle"
                    :value="item.addressId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="">
                <el-input
                  v-model="search.boxNumber"
                  style="width: 150px"
                  @input="init()"
                  @clear="init()"
                  clearable
                  placeholder="箱号"
                ></el-input>
              </el-form-item>

              

              <el-form-item label="" v-if="activeName == 'four'">
                <el-select
                  v-model="search.isOrderSend"
                  clearable
                  placeholder="是否发货单"
                  @change="init()"
                  @clear="init()"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in sendList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              
              <el-form-item label="">
                <el-select
                  v-model="search.batchNum"
                  style="width: 255px;padding-right:6px"
                  remote
                  @change="batchChange"
                  @clear="clearChecked"
                  :remote-method="remoteMethod"
                  reserve-keyword
                  filterable
                  :loading="loading"
                  clearable
                  placeholder="批次"
                >
                  <el-option
                    v-for="item in batchList"
                    :key="item.sendId"
                    :label="item.remark"
                    :value="item.remark"
                  >
                  </el-option>
                </el-select>

                <span class="search_lbl">下单时间：</span>
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  align="right"
                  style="width:300px"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate(value1)"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
                <!-- <el-form-item label="出库时间:"> -->
                <span
                  class="search_lbl"
                  style="margin-left: 10px"
                  v-if="activeName == 'four'"
                  >出库时间：</span
                >
                <el-date-picker
                  v-model="value2"
                  type="daterange"
                  align="right"
                  unlink-panels
                  style="width:300px"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate2(value2)"
                  :picker-options="pickerOptions"
                  v-if="activeName == 'four'"
                >
                </el-date-picker>
                <!-- <el-form-item label="国内入库时间:"> -->
                <span
                  class="search_lbl"
                  style="margin-left: 10px"
                  v-if="activeName == 'third'"
                  >国内入库时间：</span
                >
                <el-date-picker
                  v-model="value4"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate4(value4)"
                  :picker-options="pickerOptions"
                  v-if="activeName == 'third'"
                >
                </el-date-picker>
                <!-- <el-form-item label="结算时间:"> -->
                <span
                  class="search_lbl"
                  style="margin-left: 10px"
                  v-if="activeName == 'five'"
                  >结算时间：</span
                >
                <el-date-picker
                  v-model="value3"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate3(value3)"
                  :picker-options="pickerOptions"
                  v-if="activeName == 'five'"
                >
                </el-date-picker>

                <el-button
                  style="margin-left: 20px;margin-top:16px"
                  @click="getOrderList('1')"
                  type="primary"
                  >查询</el-button
                >
                <!-- <el-button @click="filedSel()">重置</el-button> -->
                <el-button
                  style="margin-left: 20px;margin-top:16px"
                  @click="exportToExcel()"
                  type="primary"
                  v-if="activeName != 'first'"
                  >导出Excel</el-button
                >
                <el-button
                  style="margin-left: 20px;margin-top:16px"
                  @click="
                    exportToSendOrderLook();
                    getNowData();
                  "
                  type="primary"
                  v-if="activeName == 'third'"
                  >预览客户发货单</el-button
                >
                <el-button
                  style="margin-left: 20px;margin-top:16px"
                  @click="exportToSendOrder()"
                  type="primary"
                  v-if="activeName == 'four'"
                  >批量生成发货单</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!-- //表格 -->
    <div class="table_container">
      <el-table
        :data="orderMoney"
        border
        style="width: 100%"
        height="380"
        stripe
        row-key="orderId"
        ref="table"
        @selection-change="handleSelectionChange"
        @select="selectChange"
        @row-click="handleRowClick"
      >
        <el-table-column
          type="selection"
          width="35"
          align="center"
          :selectable="selectable"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column label="名称" min-width="200px" align="left">
          <template slot-scope="scope">
            <span class="tag tag2" v-if="scope.row.orderSend">已生成</span>
            {{ scope.row.productName }}
          </template>
        </el-table-column>
        <el-table-column
          label="货物类型"
          prop="goodName"
          width="150px"
          align="left"
        >
          <template slot-scope="scope">
            <span>
              <span class="tag" v-if="scope.row.goodType == 1">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              {{ scope.row.goodName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="派送点"
          prop="deliveryTitle"
          width="120px"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.deliveryTitle }}
          </template>
        </el-table-column>
        <el-table-column
          label="客户"
          prop="userName"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
        <el-table-column
          label="vip号"
          prop="vipCode"
          min-width="60px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="125px"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.expressNo }}
            <div
              class="sign"
              v-if="scope.row.status == 1 || scope.row.status == 2"
            >
              <div v-if="scope.row.expressTime">
                国内已签收({{ toDate(scope.row.expressTime, "yyyy-MM-dd") }})
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="115px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1 && scope.row.expressStatus == 0" style="color: #d9001b">
              待签收
            </div>
            <div v-if="scope.row.status == 1 && scope.row.expressStatus == 1" style="color: #d9001b">
              待入库
            </div>
            <div v-else-if="scope.row.status == 2" style="color: #f59a23">
              已入库
            </div>
            <div v-else-if="scope.row.status == 3" style="color: #70b603">
              已出库
            </div>
            <div v-else-if="scope.row.status == 4" style="color: #70b603">
              已结单
            </div>
            <div v-else-if="scope.row.status == 5" style="color: #eea381">
              待补录
            </div>
            <div v-else-if="scope.row.status == 6" style="color: #c0e781">
              已合箱
            </div>
            <div v-else-if="scope.row.status == -1" style="color: gray">
              已取消
            </div>
            <div v-else-if="scope.row.status == 7" style="color: #f59a23">
              （中心仓）已入库
            </div>
            <div v-else-if="scope.row.status == 8" style="color: #70b603">
              （中心仓）已出库
            </div>
            <div v-else-if="scope.row.status == 9" style="color: #f59a23">
              （派送）已入库
            </div>
            <div v-else-if="scope.row.status == 10" style="color: #008b8b">
              可预约
            </div>
            <div v-else-if="scope.row.status == 11" style="color: #800080">
              已预约
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="签收人"
          width="100px"
          align="center"
          prop="expressName"
        >
        </el-table-column>
        <el-table-column
          label="尺寸"
          prop="measure"
          min-width="90px"
          align="center"
        >
        </el-table-column>
        
        
        <el-table-column
          label="商品价值"
          prop="predictTotal"
          min-width="100px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="体积"
          prop="productVolume"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="重量"
          prop="productWeight"
          min-width="60px"
          align="center"
        >
        </el-table-column>
        
        
        <el-table-column
          label="运费"
          min-width="70px"
          align="center"
          prop="total"
        >
          <template slot-scope="scope">
            {{ scope.row.total | priceFilt }}
          </template>
        </el-table-column>
        <el-table-column
          label="下单时间"
          width="100px"
          align="center"
          prop="addDate"
        >
        </el-table-column>

        <el-table-column
          label="补录时间"
          min-width="170px"
          align="center"
          prop="suppleTime"
          :key="Math.random()"
        >
          <template slot-scope="scope">
            {{ scope.row.suppleTime ? changeToTime(scope.row.suppleTime) : "" }}
          </template>
        </el-table-column>
        
        <el-table-column
          label="入库时间"
          min-width="90px"
          align="center"
          prop="storeDate"
          v-if="activeName == 'third'"
          :key="Math.random()"
        >
        </el-table-column>
        <el-table-column
          label="出库时间"
          min-width="90px"
          align="center"
          :key="Math.random()"
          prop="deliveryDate"
          v-if="activeName == 'four'"
        >
        </el-table-column>
        <el-table-column
          label="结算时间"
          min-width="90px"
          :key="Math.random()"
          align="center"
          prop="statementDate"
          v-if="activeName == 'five'"
        ></el-table-column>
        <el-table-column
          label="中心仓入库时间"
          min-width="110px"
          :key="Math.random()"
          align="center"
          prop="statementDate"
          v-if="activeName == '7'"
        >
          <template slot-scope="scope">
            {{ getTimes(scope.row, 1) }}
          </template>
        </el-table-column>
        <el-table-column
          label="中心仓出库时间"
          min-width="110px"
          :key="Math.random()"
          align="center"
          prop="statementDate"
          v-if="activeName == '8'"
        >
          <template slot-scope="scope">
            {{ getTimes(scope.row, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          label="派送入库时间"
          min-width="110px"
          :key="Math.random()"
          align="center"
          prop="storeTime"
          v-if="activeName == '9'"
        >
          <template slot-scope="scope">
            {{ getTimes(scope.row, 3) }}
          </template>
        </el-table-column>
        <el-table-column
          label="所在箱"
          :key="Math.random()"
          min-width="90px"
          align="center"
          prop="boxNumber"
          v-if="
            activeName == 'four' ||
            activeName == '7' ||
            activeName == '8' ||
            activeName == '9'
          "
        ></el-table-column>
        <el-table-column
          label="货柜号"
          min-width="90px"
          :key="Math.random()"
          align="center"
          prop="containerName"
          v-if="activeName == 'five' || activeName == '9'"
        >
        </el-table-column>
        <el-table-column
          label="批次"
          prop="batchNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="90px"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="getorderNo(scope.row.orderNo, '2', scope.row)"
              v-if="scope.row.status == 1"
              >入库</el-button
            >
            <!-- <el-button type="text" @click="getorderNo(scope.row.orderNo, '3')" v-if="scope.row.status == 2">出库</el-button> -->
            <!-- <el-button type="text" @click="getorderNoC(scope.row.orderNo)" v-if="scope.row.status == 3">结单</el-button> -->
            <el-button
              type="text"
              @click="addOrderProductDialog(scope.row)"
              v-if="scope.row.status == 5"
              >补录</el-button
            >
            <el-button
              type="text"
              @click="getorderNo(scope.row.orderNo)"
              v-if="scope.row.status != 5"
              >查看</el-button
            >

            <!-- <el-popconfirm
              confirmButtonText="确定"
              cancelButtonText="取消"
              icon="el-icon-info"
              iconColor="red"
              title="确定取消该数据？"
              @confirm="delOrder(scope.row.orderNo)"
              @onConfirm="delOrder(scope.row.orderNo)"
            > -->
              <template>
                <el-button type="text" v-if="activeName == 'third'" @click="delOrder(scope.row.orderNo)"
                  >取消</el-button
                >
              </template>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="footer">
        <div class="footer_left" v-if="activeName == 'third'">
          <el-button type="primary" size="small" @click="openBoxHanlder()"
            >合箱</el-button
          >
          <el-button type="success" size="small" @click="openExcelBoxDialog()" style="margin-left: 10px"
            >Excel批量合箱</el-button
          >
        </div>
        <div class="footer_pagination">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- </vue-scroll> -->
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showE"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您是否确认结单？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmD()">确认</el-button>
        <el-button type="primary" @click="dialog.showE = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showG"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您确认改变该合箱状态嘛？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmC()">确认</el-button>
        <el-button type="primary" @click="dialog.showG = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showF"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您确认删除该图片嘛？</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirmB()">确认</el-button>
        <el-button type="primary" @click="dialog.showF = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showD"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="800px"
      center
    >
      <div>
        <el-form :model="orderInfo" ref="search" label-position="left">
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>订单号：</div>
                <div>
                  {{ orderInfo.orderNo }}
                </div>
              </div>
            </div>
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>下单时间：</div>
                <div>
                  {{ orderInfo.addDate }}
                </div>
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>快递公司：</div>
                <div>
                  <div v-if="orderInfo.status == 2">
                    <el-select
                      v-model="orderInfo.expressCompany"
                      placeholder="请输入快递公司"
                      style="width: 208px"
                      filterable
                    >
                      <el-option
                        v-for="item in deliveyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    {{ orderInfo.expressCompany }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>快递单号：</div>
                <div>
                  <div v-if="orderInfo.status == 2">
                    <el-input
                      v-model="orderInfo.expressNo"
                      placeholder="请输入快递单号"
                      style="width: 208px"
                    ></el-input>
                  </div>
                  <div v-else>
                    {{ orderInfo.expressNo }}
                  </div>
                </div>

                <div style="margin-left: 10px" class="bt">
                  <el-button
                    type="text"
                    class="btn"
                    :data-clipboard-text="orderInfo.expressNo"
                    @click="copy"
                    >复制</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>订单状态：</div>
                <div>
                  <span v-if="orderInfo.status == 1" style="color: #d9001b">
                    待入库
                  </span>
                  <span
                    v-else-if="orderInfo.status == 2"
                    style="color: #f59a23"
                  >
                    已入库
                  </span>
                  <span v-else style="color: #70b603"> 已出库 </span>
                </div>
              </div>
            </div>
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div>预估费用：</div>
                <div>CAD {{ orderInfo.total | priceFilt }}</div>
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div style="height: 40px; line-height: 40px">订单备注：</div>
                <div>
                  <el-input v-model="orderInfo.remark" style="width: 400px" />
                </div>
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <span class="lbl_title">包裹重量KG：</span
                ><el-input
                  v-model="orderInfo.productWeight"
                  @blur="getComputer()"
                  style="width: 80px"
                />
                <span class="lbl_title lbl_margin">长CM：</span
                ><el-input
                  v-model="orderInfo.productLong"
                  @blur="getComputer()"
                  style="width: 80px"
                />
                <span class="lbl_title lbl_margin">宽CM：</span
                ><el-input
                  v-model="orderInfo.productWidth"
                  @blur="getComputer()"
                  style="width: 80px"
                />
                <span class="lbl_title lbl_margin">高CM：</span
                ><el-input
                  v-model="orderInfo.productHeight"
                  @blur="getComputer()"
                  style="width: 80px"
                />
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1 lineHeight">
                <span class="lbl_title">货物类型：</span>
                <span style="width: 220px; margin-left: 18px">
                  <!-- <el-select
                    v-model="priceGoodsId"
                    placeholder="请选择"
                    @change="seleType(priceGoodsId)"
                  >
                    <el-option
                      v-for="item in priceGoodsList"
                      :key="item.goodId"
                      :label="item.goodName+'('+goodTypeName(item.goodType)+')'"
                      :value="
                        item.goodId + ',' + item.price + ',' + item.firstWeight
                      "
                    >
                    </el-option>
                  </el-select> -->

                  <el-select
                    v-model="checkedTransType"
                    placeholder="请选择运输方式"
                    @change="seleTransType"
                    style="float: left; width: 120px"
                  >
                    <el-option
                      v-for="item in transTypeSelect"
                      :key="item.goodType"
                      :label="item.goodName"
                      :value="item.goodType"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    v-model="checkedgoodsType"
                    placeholder="物品类型"
                    @change="seleTransGoods"
                    style="
                      display: block;
                      float: left;
                      width: 120px;
                      margin: -46px 0 0 130px;
                    "
                  >
                    <el-option
                      v-for="item in transGoodSelectArr"
                      :key="item.goodId"
                      :label="item.goodName"
                      :value="
                        item.goodId + ',' + item.price + ',' + item.firstWeight
                      "
                    >
                    </el-option>
                  </el-select>
                </span>
                <span style="width: 100px; margin-left: 48px">
                  价格系数：{{ priceGoodsIdCopy.price }}
                </span>
                <span style="width: 100px">
                  首重计算：<span v-if="priceGoodsIdCopy.firstWeight == 1"
                    >是</span
                  ><span v-else>否</span>
                </span>
              </div>
            </div>
          </div>
          <div class="wrl-felxz">
            <div class="wrl-left">
              <div class="wrl-felxz1">
                <div
                  class="wrl-leftig"
                  :class="
                    weiTotal &&
                    weiTotal > 0 &&
                    Number(weiTotal) >= Number(volTotal)
                      ? 'backRed'
                      : ''
                  "
                >
                  重量费用：CAD {{ weiTotal }}
                </div>

                <div
                  :class="
                    volTotal &&
                    volTotal > 0 &&
                    Number(volTotal) > Number(weiTotal)
                      ? 'backRed'
                      : ''
                  "
                  style="margin-left: 20px"
                >
                  体积费用：CAD {{ volTotal }}
                </div>
              </div>
            </div>
          </div>
          <!-- ///入库数据 -->
          <div class="wrl-productList" style="margin: 40px 30px">
            <div class="wlr-header">
              <div class="wlr-start">
                <div>商品清单</div>
              </div>
              <div>商品入库数据(每件商品数据)</div>
              <div class="addProdauc">
                <!-- <el-button type="primary" @click="addProductB()" v-if="orderInfo.status == 2"> 添加商品</el-button> -->
              </div>
            </div>

            <div class="wrl-border"></div>
            <div>
              <div
                class="wrl-list"
                v-for="(val, i) in orderInfo.productList"
                :key="i"
              >
                <div class="wrl-flex2">
                  <div class="wrl-felx3">
                    {{ i + 1 }}
                  </div>
                  <div class="wrl-felx4" style="margin-left: 20px">
                    <div v-if="orderInfo.status == 2" style="margin-top: 8px">
                      <el-form-item
                        style="margin-bottom: 18px"
                        :prop="'productList.' + i + '.productName'"
                        :rules="[
                          {
                            required: true,
                            message: '商品名称不能为空',
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-input
                          v-model="val.productName"
                          style="width: 340px; height: 30px"
                        />
                      </el-form-item>
                    </div>
                    <div
                      class="ellipsisB"
                      style="-webkit-box-orient: vertical; width: 370px"
                      v-else
                    >
                      {{ val.productName }}
                    </div>
                    <div style="display: flex" class="wrl-felx5">
                      <div style="flex: 1">
                        <div v-if="orderInfo.status == 2">
                          <el-form-item>
                            <el-input
                              disabled
                              v-model="val.productNumB"
                              style="width: 70px; height: 30px"
                            />
                          </el-form-item>
                        </div>
                        <div v-else>
                          {{ val.productNumB }}
                          件
                        </div>
                      </div>
                      <div
                        style="flex: 2; color: #ec808d"
                        v-if="val.productRemark"
                      >
                        {{ val.productRemark }}
                      </div>
                    </div>
                  </div>
                  <!-- </div>
                   <div class="wrl-list" v-for="(val,i) in orderInfo.productListB" :key="i"> -->
                  <div class="wrl-felx44" style="margin-left: 20px">
                    <!-- <div class="ellipsisB" style=" -webkit-box-orient: vertical;"> {{val.productName}}   
                       </div> -->
                    <div
                      style="display: flex; margin-top: 5px"
                      class="wrl-felx5 inpout"
                    >
                      <div class="space">
                        <div>入库数量</div>
                        <div class="inpoutTop">
                          <el-form-item
                            :prop="'productList.' + i + '.productNum'"
                            :rules="[
                              {
                                required: true,
                                message: '入库数量不能为空',
                                trigger: 'blur',
                              },
                            ]"
                          >
                            <el-input
                              v-model="val.productNum"
                              style="width: 70px; height: 30px"
                            />
                          </el-form-item>
                        </div>
                        <!-- {{val.productNum}}件 -->
                      </div>

                      <div class="space">
                        <div>货架</div>
                        <div class="inpoutTop">
                          <el-form-item :prop="'productList.' + i + '.shelves'">
                            <el-input
                              v-model="val.shelves"
                              style="width: 70px; height: 30px"
                              @input="shelver(i, val, val.shelves)"
                            />
                            <!-- <el-input v-model="val.shelves" style="width:70px;height:30px" @input="shelver(i,val,val.shelves)"/> -->
                          </el-form-item>
                        </div>
                        <!-- {{val.weight}}kg -->
                      </div>
                      <!-- <div style="flex:2">
      {{val.productLong}}x{{val.width}}x{{val.height}}cm
     </div>
     <div style="flex:2;color:#EC808D;" v-if="val.productRemark" >
      {{val.productRemark}}
     </div> -->
                    </div>
                  </div>
                  <div
                    class="wrl-felx6"
                    v-for="(value, index) in val.productImgList"
                    :key="index"
                  >
                    <el-upload
                      class="upload-demo"
                      action=""
                      :headers="headers"
                      :http-request="handleLicenseImgFile"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                    >
                      <div
                        class="pta"
                        v-if="value.productImg"
                        @click="unpload(i, index)"
                      >
                        <i
                          class="el-icon-delete childe"
                          @click.stop="del(i, index)"
                        ></i>
                        <img
                          :src="value.productImg"
                          class="avatar"
                          :class="index > 0 ? 'spaceLeft' : ''"
                        />
                      </div>

                      <!-- <div v-else >
                        <div class="backgroundA" @click="unpload(i,index)" style="width:48px; height:48px;">
                          上传
                        </div>
                    </div> -->
                    </el-upload>
                  </div>
                  <div
                    class="wrl-felx6"
                    v-if="val.productImgList.length < 2"
                    style="margin-left: 10px"
                  >
                    <el-upload
                      class="upload-demo"
                      action=""
                      :headers="headers"
                      :http-request="handleLicenseImgFileB"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUploadB"
                    >
                      <div
                        class="backgroundA"
                        @click="unploadB(i)"
                        style="width: 48px; height: 48px"
                      >
                        上传
                      </div>
                    </el-upload>
                  </div>
                  <div class="wrl-felx6" v-if="val.productImgList.length == 0">
                    <div style="width: 48px; height: 48px"></div>
                  </div>
                  <!-- <div class="wrl-felx6" >
                    <div v-if="orderInfo.status == 2">
   <el-button type="text"  @click="deleteDialogB(i)">删除</el-button> 
                    </div>
                  </div> -->
                </div>
                <!-- <div class="wrl-flex32">
                  <div class="wrl-leftig" :class="val.weiBol ? 'backRed' : ''">
                    重量费用：CAD {{ val.weightCount | priceFilt }}
                  </div>
                  <div :class="val.volBol ? 'backRed' : ''">
                    体积费用：CAD {{ val.volumnCount | priceFilt }}
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="wrl-border"></div>
          <div class="wrl-flex56">
            <div>
              <span>折扣比率：</span>
              <span style="margin-left: 10px">
                <el-input
                  @input="changeDiscount(orderInfo.discount)"
                  v-model="orderInfo.discount"
                  @blur="getComputer()"
                  style="width: 100px"
                />
              </span>
            </div>
            <div style="margin-left: 20px">
              <span>优惠前价格：</span>
              <span style="margin-left: 10px">
                CAD {{ total | priceFilt }}
              </span>
            </div>
            <div style="color: #ec808d; margin-left: 20px">
              优惠后价格： CAD {{ discountTotal | priceFilt }}
            </div>
          </div>
          <div class="wrl-flex57">
            <div>
              <el-button
                type="primary"
                @click="onsubmitB()"
                style="width: 170px"
                >提交</el-button
              >
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showC"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
      title="修改最后费用值"
    >
      <div style="text-align: center">
        <div style="margin: 0px 0 10px 0">您确认修改嘛？</div>
        <el-input v-model="orderInfoC" @blur="cahnBlur(orderInfoC)" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="affirm(orderInfoC)">确认</el-button>
        <el-button type="primary" @click="dialog.showC = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.showB"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div style="text-align: center">
        <p>您是否将订单出库吗？该操作不可逆</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onsubmit()">确认</el-button>
        <el-button
          type="primary"
          @click="
            dialog.showB = false;
            dialog.show = false;
          "
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="600px"
      center
    >
      <div class="wrl-marign">
        <div class="wrl-hedaNa">
          <el-row>
            <span v-if="orderInfo.status == 1" style="color: #d9001b">
              <el-button
                type="primary"
                @click="instorage(orderInfo)"
                style="width: 100px"
                >入库</el-button
              >
              <el-button
                type="primary"
                @click="delOrderDiolag(orderInfo)"
                style="width: 100px"
                >取消订单</el-button
              >
              <el-button
                type="primary"
                @click="editOrder(orderInfo)"
                style="width: 100px"
                >编辑订单</el-button
              >
            </span>
            <span v-else-if="orderInfo.status == 2" style="color: #f59a23">
              <el-button
                type="primary"
                @click="instorage(orderInfo)"
                style="width: 100px"
                >重新入库</el-button
              >
              <el-button
                type="primary"
                @click="editOrder(orderInfo)"
                style="width: 100px"
                >编辑订单</el-button
              >
            </span>
          </el-row>
        </div>
        <div class="wel-flex">
          <div>订单号：</div>
          <div>{{ orderInfo.orderNo }}</div>
        </div>
        <div class="wel-flex">
          <div>下单时间：</div>
          <div>{{ orderInfo.addDate }}</div>
        </div>
        <div class="wel-flex">
          <div>客户名称：</div>
          <div>{{ orderInfo.userName }}</div>
        </div>
        <div class="wel-flex">
          <div>客户电话：</div>
          <div>{{ orderInfo.userTel }}</div>
        </div>
        <div class="wel-flex">
          <div>客户vip：</div>
          <div>{{ orderInfo.vipCode }}</div>
        </div>
        <div class="wel-flex">
          <div>快递公司：</div>
          <div>{{ orderInfo.expressCompany }}</div>
        </div>
        <div class="wel-flex">
          <div>快递单号：</div>
          <div>{{ orderInfo.expressNo }}</div>
          <div style="margin-left: 10px" class="bt">
            <el-button
              type="text"
              class="btn"
              :data-clipboard-text="orderInfo.expressNo"
              @click="copy"
              >复制</el-button
            >
          </div>
        </div>
        <div class="wel-flex">
          <div>商品价值：</div>
          <div style="color: #d9001b">{{ orderInfo.predictTotal }}</div>
        </div>
        <div class="wel-flex">
          <div>订单状态：</div>
          <div>
            <span v-if="orderInfo.status == 1" style="color: #d9001b">
              待入库
            </span>
            <span v-else-if="orderInfo.status == 2" style="color: #f59a23">
              已入库
            </span>
            <span v-else-if="orderInfo.status == 3" style="color: #70b603">
              已出库
            </span>
            <span v-else-if="orderInfo.status == 4" style="color: #70b603">
              已结单
            </span>
          </div>
        </div>
        <div class="wel-flex">
          <div>合箱状态：</div>
          <div class="bt">
            <div v-if="orderInfo.isBox == 1">
              <span>合箱</span>
            </div>
            <div v-else>
              <span type="text" class="red">不合箱</span>
            </div>
          </div>

          <div style="margin-left: 10px" class="bt">
            <el-button
              type="text"
              class="btn"
              @click="getorderNoB(orderInfo.orderNo, orderInfo.isBox)"
              v-if="orderInfo.status != 4"
              >修改</el-button
            >
          </div>
        </div>
        <div class="wel-flex" v-if="orderInfo.suppleTime">
          <div>补录时间：</div>
          <div>{{ orderInfo.suppleTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>入库时间：</div>
          <div>{{ orderInfo.storeTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 3">
          <div>出库时间：</div>
          <div>{{ orderInfo.deliveryTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.centerEnterTime">
          <div>中心入库时间：</div>
          <div>{{ orderInfo.centerEnterTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.centerOutTime">
          <div>中心出库时间：</div>
          <div>{{ orderInfo.centerOutTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.deliveryEnterTime">
          <div>派送入库时间：</div>
          <div>{{ orderInfo.deliveryEnterTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.statementTime">
          <div>派送出库时间：</div>
          <div>{{ orderInfo.statementTime }}</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>实际尺寸：</div>
          <div>
            {{ orderInfo.productSize }} CBM
            <span
              >（{{ orderInfo.productLong }}CM*{{ orderInfo.productWidth }}CM*{{
                orderInfo.productHeight
              }}CM）</span
            >
          </div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>实际重量：</div>
          <div>{{ orderInfo.productWeight }} KG</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2" style="height: 20px">
          <div>最后费用：</div>
          <div>CAD {{ orderInfo.total | priceFilt }}</div>
          <div style="margin-left: 10px">
            <el-button
              type="text"
              @click="edit(orderInfo)"
              v-if="orderInfo.status == 2"
              >修改</el-button
            >
          </div>
        </div>
        <div class="wel-flex" v-if="orderInfo.remark">
          <div>订单备注：</div>
          <!-- <div>{{orderInfo.remark}}</div> -->
          <div v-if="orderInfo.remark">{{ orderInfo.remark }}</div>
          <div v-else>无</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status >= 2">
          <div>用户备注：</div>
          <!-- <div>{{orderInfo.remark}}</div> -->
          <div v-if="orderInfo.userRemark">{{ orderInfo.userRemark }}</div>
          <div v-else>无</div>
        </div>
        <div class="wel-flex" v-if="orderInfo.status == 1">
          <div>预估费用：</div>
          <div>CAD {{ orderInfo.total | priceFilt }}</div>
        </div>
        <div class="wrl-productList">
          <div>商品清单</div>
          <div class="wrl-border"></div>
          <div
            class="wrl-list"
            v-for="(val, i) in orderInfo.productList"
            :key="i"
          >
            <div class="wrl-flex2">
              <div class="wrl-felx3">
                {{ i + 1 }}
              </div>
              <div class="wrl-felx4" style="margin-left: 20px">
                <div class="ellipsisBB" style="-webkit-box-orient: vertical">
                  {{ val.productName }}
                </div>
                <div style="display: flex; margin-top: 5px" class="wrl-felx5">
                  <div style="flex: 1">{{ val.productNum }}件</div>
                  <!-- <div style="flex: 1; min-width: 50px">{{ val.weight }}kg</div>
                  <div style="flex: 2; min-width: 100px">
                    {{ val.productLong }}x{{ val.width }}x{{ val.height }}cm
                  </div> -->
                  <div style="flex: 2; color: #ec808d" v-if="val.productRemark">
                    {{ val.productRemark }}
                  </div>
                </div>
              </div>
              <div style="margin-left: 20px" class="wrl-felx4">
                <div style="color: #ec808d" v-if="val.shelves">
                  货架: {{ val.shelves }}
                </div>
              </div>
              <div
                class="wrl-felx6 cursor"
                v-if="val.productImg"
                @click="opBa(val.productImg)"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="val.productImg"
                  fit="contain"
                ></el-image>
              </div>
              <div class="wrl-felx6" v-else>
                <div style="width: 80px; height: 80px"></div>
              </div>
              <div
                class="wrl-felx6 cursor"
                v-if="val.productImgB"
                style="margin-left: 10px"
                @click="opBa(val.productImgB)"
              >
                <el-image
                  style="width: 80px; height: 80px"
                  :src="val.productImgB"
                  fit="contain"
                ></el-image>
              </div>
              <div class="wrl-felx6" v-else>
                <div style="width: 80px; height: 80px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- //编辑订单 -->
    <el-dialog
      :visible.sync="dialog.showH"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="600px"
      title="编辑订单"
      center
    >
      <el-form
        :model="order"
        ref="netBarForm"
        label-width="55px"
        style="width: auto"
        label-position="left"
      >
        <div class="wrl-marign">
          <div class="wrl-hedaNa"></div>
          <div class="wel-flex">
            <div>订单号：</div>
            <div>{{ order.orderNo }}</div>
          </div>
          <div class="wel-flex">
            <div>下单时间：</div>
            <div>{{ order.addDate }}</div>
          </div>
          <div class="wel-flex">
            <div>客户名称：</div>
            <div>{{ order.userName }}</div>
          </div>
          <div class="wel-flex">
            <div>客户电话：</div>
            <div>{{ order.userTel }}</div>
          </div>
          <div class="wel-flex">
            <div>客户vip：</div>
            <div>{{ order.vipCode }}</div>
          </div>
          <div class="wel-flex">
            <div>快递公司：</div>
            <div>
              <el-select
                v-model="order.expressCompany"
                placeholder="请输入快递公司"
                style="width: 208px"
                filterable
              >
                <el-option
                  v-for="item in deliveyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="wel-flex">
            <div>快递单号：</div>
            <div>
              <el-input
                v-model="order.expressNo"
                placeholder="请输入快递单号"
                style="width: 208px"
              ></el-input>
            </div>
          </div>
          <div class="wel-flex">
            <div>商品价值：</div>
            <div style="color: #d9001b">
              <el-input
                @blur="checkOrder(order.predictTotal)"
                v-model="order.predictTotal"
                placeholder="整单商品价值,单位元"
                style="width: 208px"
              ></el-input>
            </div>
          </div>

          <div class="wel-flex">
            <div>订单状态：</div>
            <div>
              <span v-if="orderInfo.status == 1" style="color: #d9001b">
                待入库
              </span>
              <span v-else-if="orderInfo.status == 2" style="color: #f59a23">
                已入库
              </span>
              <span v-else-if="orderInfo.status == 3" style="color: #70b603">
                已出库
              </span>
              <span v-else-if="orderInfo.status == 4" style="color: #70b603">
                已结单
              </span>
            </div>
          </div>
          <div class="wel-flex">
            <div>合箱状态：</div>
            <div class="bt">
              <el-select
                v-model="order.isBox"
                placeholder="请输入合箱状态"
                style="width: 208px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="wel-flex">
            <div>用户备注：</div>
            <!-- <div>{{order.remark}}</div> -->
            <div v-if="order.userRemark">{{ order.userRemark }}</div>
            <div v-else>无</div>
          </div>

          <div class="wrl-productList">
            <div class="flex22">
              <div class="font">商品清单</div>
              <div class="btn">
                <el-button type="primary" @click="addProduct()">
                  添加商品</el-button
                >
              </div>
            </div>
            <div class="wrl-border"></div>
            <div class="wrl-list" v-for="(val, i) in order.detailList" :key="i">
              <div class="wrl-flex2">
                <div class="wrl-felx3">
                  {{ i + 1 }}
                </div>
                <div class="wrl-felx4" style="margin-left: 20px">
                  <el-form-item
                    style="margin-left: -55px"
                    :prop="'detailList.' + i + '.productName'"
                    :rules="[
                      {
                        required: true,
                        message: '商品名称不能为空',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="val.productName"
                      placeholder="请输入商品名称"
                      style="width: 400px"
                    ></el-input>
                  </el-form-item>
                  <div
                    style="display: flex; margin-top: -15px"
                    class="wrl-felx5"
                  >
                    <el-form-item
                      style="margin-left: -55px"
                      :prop="'detailList.' + i + '.productNum'"
                      :rules="[
                        {
                          required: true,
                          message: '商品数量不能为空',
                          trigger: 'blur',
                        },
                        { type: 'number', message: '商品数量必须为数字值' },
                      ]"
                    >
                      <el-input
                        v-model.number="val.productNum"
                        placeholder="商品数量"
                        style="width: 400px"
                      ></el-input>
                    </el-form-item>
                    <!-- <div style="flex: 1; min-width: 50px">{{ val.weight }}kg</div>
                  <div style="flex: 2; min-width: 100px">
                    {{ val.productLong }}x{{ val.width }}x{{ val.height }}cm
                  </div> -->
                  </div>
                </div>

                <div>
                  <!-- v-if="order.detailList.length>1" -->
                  <el-button type="text" @click="deleteDialog(i)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="flex4">
            <div>
              <el-button
                style="width: 150px"
                type="primary"
                @click="onSubmitOrder()"
                >提交</el-button
              >
            </div>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="adminDeleteDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定移除该商品信息嘛？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteItem(indexA)">删除</el-button>
        <el-button @click="adminDeleteDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="adminDeleteDialog.showC"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定移除该商品信息嘛？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteItemB(indexA)">删除</el-button>
        <el-button @click="adminDeleteDialog.showC = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="adminDeleteDialog.showB"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定取消该订单嘛？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="delOrder(delOrderNo)">删除</el-button>
        <el-button @click="adminDeleteDialog.showB = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //批量生成发货单 -->
    <el-dialog
      :visible.sync="adminDeleteDialog.showCC"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="540px"
      title=""
      center
    >
      <div class="showFontSize">批量生成发货单</div>
      <div class="lineHeightTop"></div>

      <div>
        <div>
          <span style="width: 100px; text-align: right; display: inline-block"
            >批量发货时间：</span
          >
          <span>
            <el-date-picker
              v-model="newDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择有效起始日期时间"
            ></el-date-picker>
          </span>
        </div>
        <div style="margin-top: 10px">
          <span style="width: 100px; text-align: right; display: inline-block"
            >发货单批次：</span
          >
          <span>
            <el-input
              type="textarea"
              :rows="3"
              v-model="sendDialog.remark"
              placeholder="请输入备注"
              style="width: 300px"
            ></el-input>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportToOrder(newDate)"
          >批量生成发货单</el-button
        >
        <el-button @click="adminDeleteDialog.showCC = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //批量生成发货单 -->
    <el-dialog
      :visible.sync="adminDeleteDialog.showD"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="540px"
      title=""
      center
    >
      <div class="showFontSize">预览客户发货单</div>
      <div class="lineHeightTop"></div>

      <div class="showFlex">
        <div>客户VIP编号：</div>
        <div>
          <el-input
            v-model="userIdCode"
            placeholder="请输入客户VIP编号"
            style="width: 300px"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportToOrderLook(userIdCode)"
          >预览客户发货单</el-button
        >
        <el-button @click="adminDeleteDialog.showD = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //查看弹框 -->
    <el-dialog
      :visible.sync="adminDeleteDialog.showF"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="900px"
      center
    >
      <div>
        <el-table
          :show-header="false"
          :data="tableData"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column
            prop="index"
            label="序号"
            align="center"
            min-width="100px"
          >
            <!-- <template slot-scope="scope">
            <span > {{scope.$index+1}}</span>
          </template> -->
          </el-table-column>
          <el-table-column
            label="订单名"
            prop="productName"
            min-width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="运单号"
            prop="expressNo"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="体积 CBM"
            prop="productSize"
            min-width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="重量 KG"
            prop="productWeight"
            min-width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="折扣率 %"
            prop="rate"
            min-width="50px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="费用 CAD"
            prop="predictTotal"
            min-width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="订单备注"
            prop="remark"
            min-width="100px"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 商品补录 -->
    <el-dialog
      :visible.sync="orderAddDialog.show"
      :title="orderAddDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="600px"
      center
    >
      <div class="order_main">
        <div class="tab_address">
          <el-tabs v-model="orderAddDialog.activeName" type="border-card">
            <el-tab-pane
              :label="item.goodName"
              :name="item.goodType"
              v-for="item in storeList"
              :key="item.goodType"
            >
              <p class="p1">{{ item.address }}</p>
              <p class="p1">{{ item.contacts }},{{ item.tel }}</p>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="order_base">
          <el-form
            :model="orderAddDialog.data"
            :rules="orderAddDialog.form_rules"
            ref="editForm"
            label-position="right"
            label-width="120px"
          >
            <el-form-item prop="expressNo" label="快递单号：">
              <el-input
                v-model="orderAddDialog.data.expressNo"
                disabled
                type="text"
                placeholder="请输入快递单号"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item prop="expressCompany" label="快递公司：">
              <el-select
                v-model="orderAddDialog.data.expressCompany"
                placeholder="请输入快递公司"
                style="width: 300px"
                filterable
              >
                <el-option
                  v-for="item in deliveyList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="predictTotal" label="商品价值：">
              <el-input
                v-model.trim="orderAddDialog.data.predictTotal"
                type="text"
                placeholder="预估价值"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注：">
              <el-input
                v-model.trim="orderAddDialog.data.remark"
                type="text"
                placeholder="请输入备注"
                style="width: 300px"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="order_detail">
          <div class="title">
            <span class="name">补录商品清单</span>
            <el-button
              type="warning"
              class="order_add"
              @click="addOrderProduct()"
              ><i class="el-icon-plus"></i> 添加商品</el-button
            >
          </div>
          <div class="product_list">
            <div
              class="p_item"
              v-for="(item, index) in orderAddDialog.data.productList"
              :key="index"
            >
              <span class="p_num">{{ index + 1 }}</span>
              <div class="p_name">
                <el-input
                  type="text"
                  v-model.trim="
                    orderAddDialog.data.productList[index].productName
                  "
                  class="p_input"
                  placeholder="请输入商品名称"
                ></el-input>
                <el-input
                  type="text"
                  v-model.trim="
                    orderAddDialog.data.productList[index].productNum
                  "
                  class="p_input"
                  placeholder="请输入商品数量"
                ></el-input>
              </div>
              <div
                class="p_del"
                v-if="index > 0"
                @click="deleteOrderProduct(index)"
              >
                <i class="el-icon-delete"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="supplementOrder()">提 交</el-button>
        <el-button @click="orderAddDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 合箱start -->
    <el-dialog
      :visible.sync="boxDialog.show"
      :title="boxDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1000px"
      center
    >
      <div class="order_main">
        <el-table
          :show-header="false"
          :data="multipleSelection"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column label="名称" min-width="200px" align="left">
            <template slot-scope="scope">
              {{ scope.row.productName }}
            </template>
          </el-table-column>
          <el-table-column
            label="货物类型"
            prop="goodName"
            width="150px"
            align="left"
          >
            <template slot-scope="scope">
              <span>
                <span class="tag" v-if="scope.row.goodType == 1">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                {{ scope.row.goodName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="客户"
            prop="userName"
            min-width="70px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.userName }}
            </template>
          </el-table-column>
          <el-table-column
            label="vip号"
            prop="vipCode"
            min-width="60px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.vipCode }}
            </template>
          </el-table-column>
          <el-table-column
            label="物流公司"
            prop="expressCompany"
            min-width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="运单号"
            prop="expressNo"
            min-width="125px"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.expressNo }}
            </template>
          </el-table-column>
          <el-table-column
            label="派送点"
            prop="deliveryTitle"
            width="120px"
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.deliveryTitle }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-popconfirm
          title="您确认合箱吗？"
          @confirm="submitBox"
          @onConfirm="submitBox"
        > -->
          <el-button slot="reference" type="primary" @click="submitBox">确认合箱</el-button>
        <!-- </el-popconfirm> -->
        <el-button @click="boxDialog.show = false" style="margin-left: 10px"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 打印面单 -->
    <el-dialog
      :visible.sync="mianDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      close="closeMianDialog()"
      center
    >
      <div style="text-align: center">
        <p>您已合箱完成，可选择：</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="mianHandler(1)">打印面单</el-button>
        <el-button type="primary" @click="mianHandler(2)">合箱列表</el-button>
      </span>
    </el-dialog>

    <!-- Excel批量合箱弹窗 -->
    <el-dialog
      :visible.sync="excelBoxDialog.show"
      title="Excel批量合箱"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
      center
      @closed="handleExcelDialogClosed"
    >
      <div class="excel-upload-container">
        <div class="upload-area">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :before-upload="beforeUpload"
            :on-change="handleFileChange"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :file-list="excelBoxDialog.fileList"
            :auto-upload="false"
            ref="excelUpload"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              <div>只能上传Excel文件(.xlsx/.xls)，且不超过10MB</div>
              <div style="margin-top: 5px; color: #909399; font-size: 12px;">
                Excel文件格式要求：第一列为运单号，系统将根据运单号自动分组合箱
              </div>
            </div>
          </el-upload>
        </div>
        
        <div v-if="excelBoxDialog.uploadProgress.show" class="upload-progress">
          <el-progress 
            :percentage="excelBoxDialog.uploadProgress.percentage" 
            :status="excelBoxDialog.uploadProgress.status"
          ></el-progress>
          <div class="progress-text">{{ excelBoxDialog.uploadProgress.text }}</div>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="excelBoxDialog.show = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="submitExcelBoxing"
          :loading="excelBoxDialog.uploading"
          :disabled="excelBoxDialog.fileList.length === 0"
        >
          {{ excelBoxDialog.uploading ? '处理中...' : '开始合箱' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 面单-->
    <Face
      v-bind:boxId="mianDialog.boxId"
      @closeFaceDialog="closeFaceDialog"
      v-if="mianDialog.isPrint"
    ></Face>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as date from "utils/date";
import * as img from "@/api/img";
import * as order from "@/api/order";
import * as confirm from "@/api/confirm";
// import * as financial from '@/api/financial'
import * as priceGoods from "@/api/priceGoods.js";
import * as addressApi from "@/api/address.js";
import Draggable from "vuedraggable";
import Sortable from "sortablejs";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { axios } from "utils/";
import * as deliveryApi from "@/api/delivery";
import * as boxApi from "@/api/box";
import Face from "../components/face";
export default {
  components: {
    Draggable,
    Face,
  },
  data() {
    let dataValidate = (rule, value, callback) => {
      let that = this;
      if (value === "") {
        let text;
        if (rule.field == "productWeight") {
          text = "包裹重量";
        } else if (rule.field == "productLong") {
          text = "包裹长度";
        } else if (rule.field == "productWidth") {
          text = "包裹宽度";
        } else if (rule.field == "productHeight") {
          text = "包裹高度";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      multipleSelection: [],
      reserveSelection: true,
      boxDialog: {
        show: false,
        title: "已选订单",
      },
      excelBoxDialog: {
        show: false,
        uploading: false,
        fileList: [],
        uploadProgress: {
          show: false,
          percentage: 0,
          status: '',
          text: ''
        }
      },
      sendDialog: {
        remark: "",
      },
      mianDialog: {
        show: false,
        isPrint: false,
        boxId: null,
      },
      deliveryAddressList: [], //派送列表
      orderAddDialog: {
        show: false,
        activeName: "1",
        title: "商品补录",
        data: {
          orderId: null,
          expressNo: "",
          expressCompany: "",
          predictTotal: null,
          remark: "",
          productList: [
            {
              productName: "",
              productNum: null,
            },
          ],
        },
        form_rules: {},
      },
      search: {
        goodType: null,
        isOrderSend: null,
        addressId: null,
        boxNumber: null,
        batchNum: null,
      },
      tableData: [],
      userIdCode: "",
      //现在时间
      newDate: "2021-11-10",
      //折扣价格
      discountTotal: "",
      priceGoodsIdCopy: {
        firstWeight: "",
        price: "",
        goodId: "",
      },
      bool: false,
      sendList: [
        {
          id: 1,
          name: "未生成发货单",
        },
        {
          id: 2,
          name: "已生成发货单",
        },
      ],
      storeList: [],
      priceGoodsId: "",
      priceGoodsList: [],
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false,
        showC: false,
        showCC: false,
        showD: false,
        showF: false,
      },
      delOrderNo: "",
      //表格信息
      deliveyList: [],
      options: [
        {
          value: "不合箱",
          id: 0,
        },
        {
          value: "合箱",
          id: 1,
        },
      ],
      order: {
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        isBox: 0,
        remark: "",
        detailList: [
          {
            detailId: 0,
            productName: "",
            productNum: "",
          },
        ],
      },
      pagTotal: false,
      pageIndexB: 0,
      pageIndex: 0,
      orderMoneyB: [],
      orderG: "",
      isBoxG: "",
      orderNOC: "",
      weiBol: false,
      volBol: false,
      galIndex: "",
      galIndexB: "",
      total: 0,
      weiTotal: 0,
      volTotal: 0,
      //图片头
      headers: {},
      orderInfoC: "",
      orderInfo: {
        orderNo: "",
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false,
        },
        rail: {
          keepShow: true,
        },
        bar: {
          //  showDelay: 3000,
          hoverStyle: false,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#C1C1C1", //滚动条颜色
          keepShow: true,
          size: "12px",
          opacity: 1, //滚动条透明度
        },
      },
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      activeName: "first",
      columns: [
        { title: "订单编号", key: "orderNo" },
        { title: "名称", key: "productName" },
        { title: "货物类型", key: "goodName" },
        { title: "派送点", key: "deliveryTitle" },
        { title: "客户", key: "userName" },
        { title: "vip号", key: "vipCode" },
        { title: "物流公司", key: "expressCompany" },
        { title: "运单号", key: "expressNo" },
        { title: "状态", key: "dealStatus" },
        { title: "签收人", key: "expressName" },
        { title: "尺寸", key: "measure" },
        { title: "联系方式", key: "userTel" },
        { title: "商品价值", key: "predictTotal" },
        { title: "体积", key: "productVolume" },
        { title: "重量", key: "productWeight" },
        { title: "运费", key: "total" },
        { title: "下单时间", key: "addDate" },
        // { title: "合箱状态", key: "boxStatus" },
        { title: "用户备注", key: "userRemark" },
        { title: "订单备注", key: "remark" },
        { title: "批次", key: "batchNumber" },
        { title: "箱号", key: "boxNumber" },
      ],
      columns2: [
        { title: "订单编号", key: "orderNo" },
        { title: "名称", key: "productName" },
        { title: "货物类型", key: "goodName" },
        { title: "派送点", key: "deliveryTitle" },
        { title: "客户", key: "userName" },
        { title: "vip号", key: "vipCode" },
        { title: "物流公司", key: "expressCompany" },
        { title: "运单号", key: "expressNo" },
        { title: "状态", key: "dealStatus" },
        { title: "签收人", key: "expressName" },
        { title: "尺寸", key: "measure" },
        { title: "联系方式", key: "userTel" },
        { title: "商品价值", key: "predictTotal" },
        { title: "体积", key: "productVolume" },
        { title: "重量", key: "productWeight" },
        { title: "运费", key: "total" },
        { title: "下单时间", key: "addDate" },
        // { title: "合箱状态", key: "boxStatus" },
        { title: "用户备注", key: "userRemark" },
        { title: "订单备注", key: "remark" },
        { title: "批次", key: "batchNumber" },
        { title: "箱号", key: "boxNumber" },
      ],
      //全局订单号
      orderNOG: "",
      //现在时间
      NowDate: "",
      //下单时间
      startTime: "",
      endTime: "",
      deliveryStartDate: "",
      deliveryEndDate: "",
      statementStartDate: "",
      statementEndDate: "",
      storeStartDate: "",
      storeEndDate: "",
      sytemPrice: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showE: false,
        showF: false,
        showG: false,
        showH: false,
      },
      beforeExpressNo: "",
      DataInformation: "",
      orderNOA: "",
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      orderMoney: [],
      orderMoney2: [],
      optionsType: [
        {
          id: 1,
          label: "全部",
        },
        {
          id: 2,
          label: "待支付",
        },
        {
          id: 3,
          label: "待结算",
        },
        {
          id: 4,
          label: "交易关闭",
        },
        {
          id: 5,
          label: "交易成功",
        },
      ],
      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankCard: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
          bankUser: [
            { required: true, trigger: "blur", validator: dataValidate },
          ],
        },
      },
      productCauserTelist: [], //款目列表存放
      confirmDialogVisible: false,
      postCount: 0,
      excelList: [],
      excelList2: [],

      checkedTransType: "",
      transTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      checkedgoodsType: "",
      transGoodSelectArr: [],
      goodsKindsArr: [],
      rukuRow: {},
      paramGoodType: "",
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      loading:false,
    };
  },
  created() {
    let that = this;
    // that.getConfig();
    that.activeName = that.$route.query.activeName
      ? that.$route.query.activeName
      : that.activeName;
    if (that.activeName == "four") {
      this.search.goodType = 1;
    }
    that.getPriceGoodsList();
    that.getOrderList();
    that.getExpressList();
    that.getStoreList();
    that.getDeliveryList();
    this.getBatchList();
  },
  methods: {
    init() {
      this.paginations.page_index = 1;
      this.getOrderList();
    },
    mianHandler(type) {
      this.mianDialog.show = false;
      if (type == 1) {
        this.mianDialog.isPrint = true;
      } else {
        this.$router.push("/order/box");
      }
    },
    closeMianDialog() {
      this.multipleSelection = [];
    },
    closeFaceDialog(val) {
      this.mianDialog.isPrint = false;
    },
    selectable(row, index) {
      if (this.activeName != "third") {
        return false;
      } else {
        return true;
      }
    },
    openBoxHanlder() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.error("请选择订单");
      }
      this.boxDialog.show = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectChange(selection, row) {
      if (selection.length > 0) {
        let data = row;
        let data2 = selection[0];
        if (
          (data &&
            data2 &&
            data.goodType &&
            data2.goodType &&
            data.goodType != data2.goodType) ||
          (data &&
            data2 &&
            data.deliveryTitl &&
            data2.deliveryTitle &&
            data.deliveryTitle != data2.deliveryTitle)
        ) {
          const del_row = selection.pop();
          this.$refs.table.toggleRowSelection(del_row, false);
          return this.$message.error("合箱订单运输方式和派送点一致");
        }
      }
    },
    // 点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
      this.selectChange(this.multipleSelection);
    },
    submitBox() {
      //合箱
      let that = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.error("请选择订单");
      }
      let param = {};
      let orderList = [];
      this.multipleSelection.forEach((item) => {
        let obj = {};
        obj.orderId = item.orderId;
        orderList.push(obj);
      });
      that.multipleSelection = [];
      param.orderList = orderList;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.combinedBox(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "提交失败");
        }
        that.$message({
          message: "合箱成功!",
          type: "success",
        });

        that.boxDialog.show = false;
        that.getOrderList();
        that.handleSelectionChange();
        that.multipleSelection = [];
        that.$refs.table.clearSelection();
        // that.mianDialog.show = true;
        that.mianDialog.boxId = res.data.data.boxId;
      });
    },
    // Excel批量合箱相关方法
    openExcelBoxDialog() {
      this.excelBoxDialog.show = true;
      this.excelBoxDialog.fileList = [];
      this.excelBoxDialog.uploading = false;
      this.excelBoxDialog.uploadProgress.show = false;
    },
    handleExcelDialogClosed() {
      // 重置上传状态
      this.excelBoxDialog.fileList = [];
      this.excelBoxDialog.uploading = false;
      this.excelBoxDialog.uploadProgress.show = false;
      if (this.$refs.excelUpload) {
        this.$refs.excelUpload.clearFiles();
      }
    },
    beforeUpload(file) {
      return false; // 阻止自动上传，使用手动上传
    },
    handleFileChange(file, fileList) {
      // 清空之前的文件列表，只保留最新选择的文件
      if (fileList.length > 1) {
        fileList = [fileList[fileList.length - 1]];
      }
      
      if (fileList.length === 0) {
        this.excelBoxDialog.fileList = [];
        return;
      }
      
      const currentFile = fileList[0];
      
      // 文件格式验证
      const isExcel = currentFile.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                     currentFile.raw.type === 'application/vnd.ms-excel' ||
                     currentFile.name.endsWith('.xlsx') || 
                     currentFile.name.endsWith('.xls');
      
      if (!isExcel) {
        this.$message.error('只能上传Excel文件(.xlsx/.xls)!');
        this.excelBoxDialog.fileList = [];
        this.$refs.excelUpload.clearFiles();
        return;
      }
      
      // 文件大小验证 (10MB)
      const isLt10M = currentFile.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        this.excelBoxDialog.fileList = [];
        this.$refs.excelUpload.clearFiles();
        return;
      }
      
      // 更新文件列表
      this.excelBoxDialog.fileList = [currentFile.raw];
      console.log('文件选择成功:', currentFile.name, '文件列表长度:', this.excelBoxDialog.fileList.length);
    },
    submitExcelBoxing() {
      if (this.excelBoxDialog.fileList.length === 0) {
        this.$message.error('请选择要上传的Excel文件');
        return;
      }
      
      const file = this.excelBoxDialog.fileList[0];
      this.excelBoxDialog.uploading = true;
      this.excelBoxDialog.uploadProgress.show = true;
      this.excelBoxDialog.uploadProgress.percentage = 0;
      this.excelBoxDialog.uploadProgress.status = '';
      this.excelBoxDialog.uploadProgress.text = '正在上传文件...';
      
      // 模拟上传进度
      const progressTimer = setInterval(() => {
        if (this.excelBoxDialog.uploadProgress.percentage < 90) {
          this.excelBoxDialog.uploadProgress.percentage += 10;
        }
      }, 200);
      
      boxApi.excelBatchBoxing(file).then((res) => {
        clearInterval(progressTimer);
        this.excelBoxDialog.uploading = false;
        this.excelBoxDialog.uploadProgress.percentage = 100;
        
        if (res.data.code !== 0) {
          this.excelBoxDialog.uploadProgress.status = 'exception';
          this.excelBoxDialog.uploadProgress.text = res.data.msg || '合箱失败';
          this.$message.error(res.data.msg || '合箱失败');
          return;
        }
        
        this.excelBoxDialog.uploadProgress.status = 'success';
        this.excelBoxDialog.uploadProgress.text = '合箱成功！';
        this.$message.success(res.data.msg || 'Excel批量合箱成功!');
        
        // 延迟关闭弹窗并刷新列表
        setTimeout(() => {
          this.excelBoxDialog.show = false;
          this.getOrderList(); // 刷新订单列表
        }, 1500);
        
      }).catch((error) => {
        clearInterval(progressTimer);
        this.excelBoxDialog.uploading = false;
        this.excelBoxDialog.uploadProgress.status = 'exception';
        
        // 检查是否是接口未实现的错误
        if (error.response && error.response.status === 404) {
          this.excelBoxDialog.uploadProgress.text = '接口暂未实现';
          this.$message.warning('Excel批量合箱接口暂未实现，请联系后端开发人员');
        } else if (error.response && error.response.status === 500) {
          this.excelBoxDialog.uploadProgress.text = '服务器错误';
          this.$message.error('服务器内部错误，请稍后再试');
        } else {
          this.excelBoxDialog.uploadProgress.text = '上传失败';
          this.$message.error('网络错误，上传失败');
        }
        
        console.error('Excel批量合箱失败:', error);
      });
    },
    handleUploadSuccess(response, file, fileList) {
      // 这个方法在自动上传模式下使用，当前我们使用手动上传，所以这里可以为空
    },
    handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败');
      console.error('上传错误:', err);
    },
    getDeliveryList() {
      let that = this;
      let data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code != 0) {
          return;
        }
        if (res.data.code == 0) {
          that.deliveryAddressList = res.data.data.list;
        }
      });
    },
    addOrderProductDialog(row) {
      this.orderAddDialog.show = true;
      this.orderAddDialog.data = {
        orderId: row.orderId,
        expressNo: row.expressNo,
        expressCompany: row.expressCompany,
        remark: row.remark,
        predictTotal: row.predictTotal ? row.predictTotal : null,
        productList: [
          {
            productName: "",
            productNum: null,
          },
        ],
      };
    },
    addOrderProduct() {
      let obj = {
        productName: "",
        productNum: null,
      };
      this.orderAddDialog.data.productList.push(obj);
    },
    deleteOrderProduct(index) {
      this.orderAddDialog.data.productList.splice(index, 1);
    },
    supplementOrder() {
      let that = this;
      let param = {};
      let store =
        that.storeList &&
        that.storeList.filter((item) => {
          return item.goodType == that.orderAddDialog.activeName;
        });
      param.orderId = that.orderAddDialog.data.orderId;
      param.expressCompany = that.orderAddDialog.data.expressCompany;
      param.predictTotal = that.orderAddDialog.data.predictTotal;
      param.remark = that.orderAddDialog.data.remark;
      param.contacts = store ? store[0].contacts : "";
      param.tel = store ? store[0].tel : "";
      param.address = store ? store[0].address : "";
      param.goodType = that.orderAddDialog.activeName;
      that.orderAddDialog.data.productList.forEach((item, index) => {
        if (!item.productName) {
          return that.$message.error("商品名称不能为空！");
        } else if (!item.productNum) {
          return that.$message.error("商品数量不能为空！");
        }
      });
      param.detailList = that.orderAddDialog.data.productList;

      order.supplementOrder(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({ message: "提交成功", type: "success" });
        that.orderAddDialog.show = false;
        that.getOrderList();
      });
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodTypeName(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    exportToOrderLook(val) {
      this.adminDeleteDialog.showD = false;
      this.adminDeleteDialog.showF = true;
      this.getPreviewOrders(val);
    },
    getStoreList() {
      let that = this;
      let data = {};
      addressApi.getStoreList(data).then(function (res) {
        if (res.data.code == 0) {
          let dataList = res.data.data.list || null;
          if (dataList && dataList.length > 0) {
            let store1 = dataList.filter((item) => {
              return item.goodType == 1;
            });
            let store2 = dataList.filter((item) => {
              return item.goodType == 2;
            });
            let store3 = dataList.filter((item) => {
              return item.goodType == 3;
            });
            let storeList = [];
            let obj = {};
            obj.goodType = "1";
            obj.goodName = "海运";
            obj.contacts = store1 ? store1[0].contacts : "";
            obj.tel = store1 ? store1[0].tel : "";
            obj.address = store1 ? store1[0].address : "";
            storeList.push(obj);

            obj = {};
            obj.goodType = "2";
            obj.goodName = "海运大件";
            obj.contacts = store1 ? store2[0].contacts : "";
            obj.tel = store1 ? store2[0].tel : "";
            obj.address = store1 ? store2[0].address : "";
            storeList.push(obj);

            obj = {};
            obj.goodType = "3";
            obj.goodName = "空运";
            obj.contacts = store1 ? store3[0].contacts : "";
            obj.tel = store1 ? store3[0].tel : "";
            obj.address = store1 ? store3[0].address : "";
            storeList.push(obj);

            that.storeList = storeList;
          }
        }
      });
    },
    //获取详情
    getPreviewOrders(val) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        vipCode: val,
      };
      let standard = 0,
        countTotal = 0;
      order.sendPreviewOrders(data).then((res) => {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              }
            });
          }
          let obj = {};
          let arr = [];
          obj.index = "VIP号：";
          obj.productName = res.data.data.vipCode;
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = countTotal ? countTotal.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用";
          obj.remark = 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          let subTotal = mUtils.accAdd(countTotal, standard);
          obj.remark = subTotal ? subTotal.toFixed(2) : 0;
          arr.push(obj);
          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    //打开弹框
    exportToSendOrder() {
      this.adminDeleteDialog.showCC = true;
      this.getNowData();
    },
    exportToSendOrderLook() {
      this.adminDeleteDialog.showD = true;
    },
    exportToOrder(val) {
      let that = this;

      let data = {
        sendTime: new Date(val).getTime(),
        userId: Number(mUtils.getStore("userinfo").adminId),
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate:
          that.deliveryStartDate && that.activeName == "four"
            ? that.deliveryStartDate
            : null,
        deliveryEndDate:
          that.deliveryEndDate && that.activeName == "four"
            ? that.deliveryEndDate
            : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        remark: that.sendDialog.remark,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
      };

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      order.sendOrder(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("批量生成失败");
          return;
        } else {
          that.$message.success("批量生成成功");
          that.adminDeleteDialog.showCC = false;
          that.activeName = that.$route.query.activeName
            ? that.$route.query.activeName
            : that.activeName;

          that.init();
          that.getOrderList();
          that.getStoreList();
          that.getDeliveryList();
        }
      });
      loading.close();
    },
    changeDiscount(val) {
      this.orderInfo.discount = val;
      this.$forceUpdate();
    },
    seleType(val) {
      let that = this;
      that.priceGoodsIdCopy.goodId = val.split(",")[0];
      that.priceGoodsIdCopy.price = val.split(",")[1];
      that.priceGoodsIdCopy.firstWeight = val.split(",")[2];
      that.sytemPrice = val.split(",")[1];
      that.getComputer();
    },
    seleTransType(goodType) {
      let that = this;

      that.checkedgoodsType = ""; // 清空物品类型

      let newArr = that.goodsKindsArr.filter(function (value, index, array) {
        return value.goodType == goodType;
      });
      that.transGoodSelectArr = newArr;
      that.paramGoodType = goodType;
    },

    seleTransGoods(val) {
      let that = this;
      that.priceGoodsIdCopy.goodId = val.split(",")[0];
      that.priceGoodsIdCopy.price = val.split(",")[1];
      that.priceGoodsIdCopy.firstWeight = val.split(",")[2];
      that.sytemPrice = val.split(",")[1];

      that.checkedgoodsType = val;
      that.getComputer();
    },
    /**
     * @name
     * @description 获取类型列表
     * @main_method post(url,data)
     * @interface getPriceGoodsList
     */
    getPriceGoodsList() {
      let that = this;

      let data = {
        pageIndex: 1,
        pageSize: 50,
      };

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      priceGoods.goodList(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          that.priceGoodsId =
            res.data.data.list[0].goodId +
            "," +
            res.data.data.list[0].price +
            "," +
            res.data.data.list[0].firstWeight;
          that.priceGoodsIdCopy.price = res.data.data.list[0].price;
          that.priceGoodsIdCopy.firstWeight = res.data.data.list[0].firstWeight;
          that.priceGoodsIdCopy.goodId = res.data.data.list[0].goodId;
          that.sytemPrice = res.data.data.list[0].price;
          that.priceGoodsList = res.data.data.list;
          // that.paginations.total = res.data.data.pageCount;
          that.goodsKindsArr = res.data.data.list;
        }
      });
      loading.close();
    },
    checkOrder(val) {
      let that = this;
      let reg = /^\d+$|^\d*\.\d+$/g;
      if (!reg.test(val)) {
        that.$message.warning("只能输入数字和小数点");
      }
    },
    deleteItem(index) {
      this.adminDeleteDialog.show = false;
      this.order.detailList.splice(index, 1);
      // this.dialog.detailList.splice(index, 1);
    },
    //删除
    deleteDialog(index) {
      this.indexA = index;
      this.adminDeleteDialog.show = true;
    },
    deleteDialogB(index) {
      this.indexA = index;
      this.adminDeleteDialog.showC = true;
    },
    deleteItemB(index) {
      this.adminDeleteDialog.showC = false;
      this.orderInfo.productList.splice(index, 1);
      // this.dialog.detailList.splice(index, 1);
    },
    //增加
    addProduct() {
      this.order.detailList.push({
        detailId: 0,
        productName: "",
        productNum: "",
      });
    },
    //入库
    addProductB() {
      this.orderInfo.productList.push({
        detailId: 0,
        productName: "",
        productNameB: "",
        productNumB: "",
        productRemark: "",
        productNum: "",
        shelves: "",
        productImgList: [
          {
            productImg: "",
          },
        ],
      });
      this.$forceUpdate();
    },
    //编辑订单
    //提交表单
    onSubmitOrder() {
      let that = this;
      let data = {};
      if (!that.order.detailList.length) {
        that.$message.warning("请添加商品");
        return;
      }
      if (!that.order.expressNo) {
        that.$message.warning("请添加快递单号");
        return;
      }
      if (!that.order.predictTotal) {
        that.$message.warning("请填写商品价值");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      let validd;
      that.$refs.netBarForm.validate((valid) => {
        validd = valid;
        return true;
      });

      if (validd) {
        data = {
          operatorId: mUtils.getStore("userinfo").adminId,
          orderNo: that.order.orderNo,
          vipCode: that.order.vipCode,
          expressCompany: that.order.expressCompany,
          expressNo: that.order.expressNo,
          predictTotal: that.order.predictTotal,
          isBox: that.order.isBox,
          remark: that.order.remark || "",
          detailList: that.order.detailList,
        };

        order.createOrder(data).then(function (res) {
          if (res.data.code != 0) {
          } else {
            that.getOrderList();
            that.dialog.showH = false;
            that.dialog.show = false;
            let msg = "添加成功";
            that.$message({
              message: msg,
              type: "success",
            });

            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    //b编辑订单
    editOrder(val) {
      let that = this;
      that.order = val;
      let obj = {};
      let arr = [];
      val.detailList.forEach(function (value, i) {
        obj = {};
        obj.detailId = value.detailId;
        obj.productName = value.productName;
        obj.productNum = value.productNum;
        arr.push(obj);
      });
      that.order.detailList = arr;

      that.dialog.showH = true;
    },
    //取消
    delOrderDiolag(val) {
      this.delOrderNo = val.orderNo;
      this.adminDeleteDialog.showB = true;
    },
    delOrder(val) {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      data = {
        orderNo: val,
      };
      order.cancelOrder(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("取消订单失败");
          return;
        }
        that.adminDeleteDialog.showB = false;
        that.dialog.show = false;
        that.getOrderList();
      });
    },
    //获取
    getExpressList() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      confirm.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.deliveyList = res.data.data;
      });
    },
    //确认
    affirmC() {
      let that = this;
      let isbox = "";
      if (that.isBoxG == 0) {
        isbox = 1;
      } else {
        isbox = 0;
      }
      let obj = {};
      obj.orderNo = that.orderG;
      obj.operatorId = mUtils.getStore("userinfo").adminId;
      obj.isBox = isbox;
      order.updateBox(obj).then((res) => {
        if (res.data.code == 0) {
          that.$message.success("改变成功！");

          that.dialog.showG = false;
          that.getorderNo(that.orderG);
          that.getOrderList();
        } else {
          that.$message.error("改变失败！");
        }
      });
    },
    getorderNoB(val, isbox) {
      this.orderG = val;
      this.isBoxG = isbox;
      this.dialog.showG = true;
    },
    //确认订单
    getorderNoC(val) {
      this.orderG = val;
      this.dialog.showE = true;
    },
    //实时
    realDate(val) {
      let that = this;
      that.paginations.page_index = 1;
      if (val.length >= 2) {
        that.getOrderList("1");
      } else if (val.length == 0) {
        that.getOrderList("1");
      }
    },
    inputOrder(val) {
      let that = this;
      that.paginations.page_index = 1;
      if (val.length >= 4) {
        that.getOrderList("1");
      } else if (val.length == 0) {
        that.getOrderList("1");
      }
    },
    opBa(val) {
      window.open(val, "_blank");
    },
    shelver(i, val, value) {
      this.$forceUpdate();
    },
    // 提交订单入库(status=2),出库(status=3)
    onsubUpdate(type) {
      let that = this;

      let status = 0;
      let mse = "";
      if (type == 2) {
        status = 2;
        mse = "入库";
      } else {
        mse = "出库";
        status = 3;
      }
      let arr = [];
      let obj = {};
      that.orderInfo.productList.forEach(function (val, i) {
        obj = {};
        obj.productName = val.productName;

        obj.detailId = val.detailId;
        obj.productNum = val.productNum;
        obj.weight = val.weight || 0;
        obj.productLong = val.productLong || 0;
        obj.width = val.width || 0;
        obj.height = val.height || 0;
        if (val.shelves) {
          obj.shelves = val.shelves;
        } else {
          obj.shelves = "";
        }
        if (val.productImgList.length) {
          val.productImgList.forEach(function (value, index) {
            if (index == 0) {
              obj.pic = value.productImgB;
            } else {
              obj.pic = obj.pic + "," + value.productImgB;
            }
          });
        } else {
          obj.pic = "";
        }
        arr.push(obj);
      });
      if (status == 2) {
        if (!that.orderInfo.productWeight) {
          return that.$message.error("包裹重量不能为空");
        }
        if (!that.orderInfo.productLong) {
          return that.$message.error("长度不能为空");
        }
        if (!that.orderInfo.productWidth) {
          return that.$message.error("宽度不能为空");
        }
        if (!that.orderInfo.productHeight) {
          return that.$message.error("高度不能为空");
        }
        if (!that.checkedgoodsType) {
          return that.$message.error("物品类型不能为空");
        }
      }
      let data = {
        orderNo: that.orderInfo.orderNo,
        status: status,
        subTotal: that.total,
        total: that.discountTotal,
        weightTotal: that.weiTotal,
        volumeTotal: that.volTotal,
        operatorId: mUtils.getStore("userinfo").adminId,
        rate: that.orderInfo.discount,
        productWeight: that.orderInfo.productWeight,
        productHeight: that.orderInfo.productHeight,
        productLong: that.orderInfo.productLong,
        productWidth: that.orderInfo.productWidth,
        remark: that.orderInfo.remark ? that.orderInfo.remark : null,
        goodId: that.priceGoodsIdCopy.goodId,
        priceFactor: that.sytemPrice,
        detailList: arr,
        goodType: that.paramGoodType,
      };

      order.uploadOrderInfo(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.$message.success(mse + "保存成功");
          that.dialog.showD = false;
          that.dialog.show = false;
          that.dialog.showC = false;
          that.dialog.showB = false;
          that.getOrderList();
        } else {
          that.$message.error(mse + "保存失败");
        }
      });
    },
    getorderNo(val, ind, row) {
      let that = this;
      if (row) {
        that.rukuRow = row;
        that.checkedTransType = row.goodType;
        that.paramGoodType = row.goodType;
        that.checkedgoodsType = "";
        let newArr = that.goodsKindsArr.filter(function (value, index, array) {
          return value.goodType == row.goodType;
        });
        that.transGoodSelectArr = newArr;
      }

      that.volTotal = 0;
      that.weiTotal = 0;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        orderNo: val,
      };

      order.getOrderInfo(data).then((res) => {
        if (res.data.code == 0) {
          that.orderInfo = res.data.data;
          that.priceGoodsList.forEach(function (val, i) {
            if (val.goodId == res.data.data.goodId) {
              that.priceGoodsId =
                val.goodId + "," + val.price + "," + val.firstWeight;
              that.priceGoodsIdCopy.price = val.price;
              that.priceGoodsIdCopy.firstWeight = val.firstWeight;
              that.sytemPrice = val.price;
            }
          });
          that.orderInfo.addDate = mUtils
            .formatDate(new Date(that.orderInfo.addTime))
            .substring(0, 16);
          that.orderInfo.storeTime = mUtils
            .formatDate(new Date(that.orderInfo.storeTime))
            .substring(0, 16);
          that.orderInfo.deliveryTime = mUtils
            .formatDate(new Date(that.orderInfo.deliveryTime))
            .substring(0, 16);
          // that.orderInfo.detailList.forEach(function(val,i){
          //      val.shelves='12321'
          // })
          that.orderInfo.centerEnterTime ? that.orderInfo.centerEnterTime = mUtils
            .formatDate(new Date(that.orderInfo.centerEnterTime))
            .substring(0, 16) :"";
          
          that.orderInfo.centerOutTime ? that.orderInfo.centerOutTime = mUtils
            .formatDate(new Date(that.orderInfo.centerOutTime))
            .substring(0, 16) :"";

          that.orderInfo.deliveryEnterTime ? that.orderInfo.deliveryEnterTime = mUtils
            .formatDate(new Date(that.orderInfo.deliveryEnterTime))
            .substring(0, 16) :"";
          // 派送出库时间（已结算时间）
          that.orderInfo.statementTime ? that.orderInfo.statementTime = mUtils
            .formatDate(new Date(that.orderInfo.statementTime))
            .substring(0, 16) :"";
          that.orderInfo.suppleTime ? that.orderInfo.suppleTime = mUtils
            .formatDate(new Date(that.orderInfo.suppleTime))
            .substring(0, 16) :"";

          that.orderInfo.productList = that.orderInfo.detailList;
          if (res.data.data.rate) {
            that.orderInfo.discount = res.data.data.rate;
          } else {
            that.orderInfo.discount = 100;
          }
          let arr = [];
          let arrB = [];
          let obj = {};
          that.orderInfo.productList.forEach(function (val, i) {
            //  val.shelves=''

            arrB = [];
            val.productImgList = [];

            if (val.pic) {
              if (val.pic.indexOf(",") != -1) {
                arr = val.pic.split(",");
                val.productImg = that.orderInfo.httpUrl + val.pic.split(",")[0];
                val.productImgB =
                  that.orderInfo.httpUrl + val.pic.split(",")[1];
                arr.forEach(function (value, index) {
                  obj = {};
                  obj.productImg = that.orderInfo.httpUrl + value;
                  obj.productImgB = value;
                  arrB.push(obj);
                });
              } else {
                val.productImg = that.orderInfo.httpUrl + val.pic;
                obj = {};
                obj.productImg = that.orderInfo.httpUrl + val.pic;
                obj.productImgB = val.pic;
                arrB.push(obj);
              }
            }
            val.productImgList = arrB;
          });

          if (ind == 2) {
            that.orderInfo.productList.forEach(function (val, i) {
              val.weiBol = false;
              val.volBol = false;
              val.shelves = val.shelves;
              val.productNumB = val.productNum;
              val.weightB = val.weight;
              val.productLongB = val.productLong;
              val.widthB = val.width;
              val.heightB = val.height;
              // val.heightB=val.height
            });
            //that.getComputer();
            that.dialog.showD = true;
          } else if (ind == 3) {
            that.dialog.showB = true;
          } else {
            that.dialog.show = true;
          }
          that.$forceUpdate();
          loading.close();
        }
      });
    },
    getDate(value1) {
      if (!value1) {
        this.startTime = "";
        this.endTime = "";
        this.getOrderList("1");
        return;
      }
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime =
        new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.getOrderList("1");
    },
    getDate2(value1) {
      if (!value1) {
        this.deliveryStartDate = "";
        this.deliveryEndDate = "";
        this.getOrderList("1");
        return;
      }
      this.deliveryStartDate = new Date(mUtils.formatDate(value1[0])).getTime();
      this.deliveryEndDate =
        new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.getOrderList("1");
    },
    getDate3(value1) {
      if (!value1) {
        this.statementStartDate = "";
        this.statementEndDate = "";
        return;
      }
      this.statementStartDate = new Date(
        mUtils.formatDate(value1[0])
      ).getTime();
      this.statementEndDate = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    getDate4(value1) {
      if (!value1) {
        this.storeStartDate = "";
        this.storeEndDate = "";
        return;
      }
      this.storeStartDate = new Date(mUtils.formatDate(value1[0])).getTime();
      this.storeEndDate = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    cahnBlur(val) {
      let that = this;
      let numReg = /^\d+(\.\d+)?$/;

      if (!numReg.test(val)) {
        that.$message.warning("请输入数字");
      } else {
        if (val < 0) {
          that.$message.warning("请输入大于等于0的值");
        }
      }
    },
    copy() {
      var that = this;

      var clipboard = new this.Clipboard(".btn"); //在main.js中引用
      clipboard.on("success", (e) => {
        // 释放内存
        that.$message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        that.$message.warning("该浏览器不支持自动复制");
        // Message({
        //   message: "该浏览器不支持自动复制",
        //   type: "warning"
        // });
        // 释放内存
        clipboard.destroy();
      });
    },
    //计算价格
    getComputer() {
      let that = this;
      let total = 0;
      let weiCount = 0;
      let volCount = 0;

      let good = that.priceGoodsList.filter((res) => {
        return res.goodId == that.priceGoodsIdCopy.goodId;
      });
      let productWeight = 0,
        productVolumn = 0;
      //重量
      if (that.orderInfo.productWeight) {
        if (good[0].goodType == 1) {
          productWeight =
            that.orderInfo.productWeight <= 1 && good[0].firstWeight == 1
              ? 1
              : that.orderInfo.productWeight;
          //weiCount = w * good[0].price;
        } else if (good[0].goodType == 3) {
          productWeight = that.orderInfo.productWeight;
        }
      }
      //体积
      if (
        that.orderInfo.productLong > 0 &&
        that.orderInfo.productWidth > 0 &&
        that.orderInfo.productHeight > 0
      ) {
        if (good[0].goodType == 2) {
          //海运大件
          let v1 = (
            (that.orderInfo.productLong / 100) *
            (that.orderInfo.productWidth / 100) *
            (that.orderInfo.productHeight / 100)
          ).toFixed(4);
          let v2 = Math.ceil(v1 * 2);
          let v = v2 / 2;
          productVolumn = v <= 1 && good[0].firstWeight == 1 ? 1 : v;
          // volCount = v * good[0].price;
        } else if (good[0].goodType == 3) {
          //空运
          let v = (
            (that.orderInfo.productLong *
              that.orderInfo.productWidth *
              that.orderInfo.productHeight) /
            5000
          ).toFixed(4);
          productVolumn = v;

          //volCount = v * good[0].price;
        } else {
          let v = (
            (that.orderInfo.productLong *
              that.orderInfo.productWidth *
              that.orderInfo.productHeight) /
            6000
          ).toFixed(4);
          productVolumn = v <= 1 && good[0].firstWeight == 1 ? 1 : v;
          //volCount = v * good[0].price;
        }
      }

      let v = good[0].goodType == 3 ? productVolumn * 2.2 : productVolumn;
      let v2 = good[0].goodType == 3 ? productWeight * 2.2 : productWeight;
      let productVolumn2 = v <= 1 && good[0].firstWeight == 1 ? 1 : v;
      let productWeight2 = v2 <= 1 && good[0].firstWeight == 1 ? 1 : v2;

      if (parseFloat(productWeight) > parseFloat(productVolumn)) {
        total = productWeight2;
      } else {
        total = productVolumn2;
      }

      if (good[0].goodType == 3) {
        volCount = parseFloat((productVolumn2 * good[0].price).toFixed(2));
        weiCount = parseFloat((productWeight2 * good[0].price).toFixed(2));
        total = parseFloat((total * good[0].price).toFixed(2));
      } else {
        weiCount = productWeight2 * good[0].price;
        volCount = productVolumn2 * good[0].price;
        total = total * good[0].price;
      }

      that.weiTotal = weiCount ? weiCount.toFixed(2) : 0;
      that.volTotal = volCount ? volCount.toFixed(2) : 0;
      that.total = total ? total.toFixed(2) : 0;
      that.discountTotal = total
        ? (mUtils.accMul(total, that.orderInfo.discount) / 100).toFixed(2)
        : 0;
      return;
    },
    affirmB() {
      let that = this;
      let val = that.galIndex;
      let i = that.galIndexB;
      that.orderInfo.productList[val].productImgList.splice(i, 1);
      that.$forceUpdate();
      that.dialog.showF = false;
    },
    //
    del(val, index) {
      let that = this;
      that.galIndex = val;
      that.galIndexB = index;
      that.dialog.showF = true;
      // that.orderInfo.productList[val].productImg=''
    },
    //提交
    onsubmitB() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let validd;
      that.$refs.search.validate((valid) => {
        validd = valid;
        return true;
      });

      if (validd) {
        that.onsubUpdate("2");
        loading.close();
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    //重新入库
    instorage(value) {
      let that = this;
      that.getExpressList();
      that.orderInfo = value;
      that.orderInfo.productList.forEach(function (val, i) {
        val.productNumB = val.productNum;
        val.weightB = val.weight;
        val.productLongB = val.productLong;
        val.widthB = val.width;
        val.heightB = val.height;
      });
      that.getComputer();
      that.dialog.showD = true;
    },
    affirmD() {
      let that = this;
      let data = {
        orderNo: that.orderG,
        status: 4,
        operatorId: mUtils.getStore("userinfo").adminId,
        remark: null,
        detailList: null,
      };
      order.uploadOrderInfo(data).then((res) => {
        if (res.data.code == 0) {
          that.$message.success("结单成功");
          that.dialog.showE = false;

          that.getOrderList();
        } else {
          that.$message.error("结单失败");
        }
      });
    },
    affirm(val) {
      let that = this;

      let numReg = /^\d+(\.\d+)?$/;

      if (!numReg.test(val)) {
        that.$message.warning("请输入数字");
        return;
      } else {
        if (val < 0) {
          that.$message.warning("请输入大于等于0的值");
          return;
        } else {
          const loading = this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)",
          });
          setTimeout(function () {
            loading.close();
          }, 5000);
          let data = {
            orderNo: that.orderNOG,
            operatorId: mUtils.getStore("userinfo").adminId,
            total: val,
          };
          order.updateOrderTotal(data).then((res) => {
            if (res.data.code == 0) {
              that.dialog.showC = false;
              that.getorderNo(that.orderNOG);
              loading.close();
            } else {
              that.$message.error("修改错误");
            }
          });
        }
      }
    },
    edit(orderInfo) {
      let that = this;
      that.orderInfoC = orderInfo.total;
      that.orderNOG = orderInfo.orderNo;
      that.dialog.showC = true;
    },
    outbound(orderInfo) {
      let that = this;

      that.orderInfo = orderInfo;
      that.dialog.showB = true;
    },
    handleClick(tab, event) {
      let that = this;
      that.search.batchNum = "";
      this.$refs.table.clearSelection();
      if (tab.name == "6") {
        that.$router.push("/order/box");
        return;
      }
      if (tab.name == "four") {
        this.search.goodType = 1;
      }
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.activeName = tab.name;
      that.orderMoneyB = [];
      that.paginations.page_index = 1;
      that.getOrderList();
    },
    unploadB(i) {
      let that = this;
      that.galIndex = i;
    },
    unpload(i, index) {
      let that = this;
      that.galIndex = i;
      that.galIndexB = index;
    },
    handleLicenseImgFileB: function (file) {
      let that = this;

      let i = that.galIndex;
      let index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            let msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");

          let obj = {};
          obj.productImg = res.data.data.data.path;
          obj.productImgB = res.data.data.data.url;
          that.orderInfo.productList[i].productImgList.push(obj);
          that.$forceUpdate();

          loading.close();
        }
      });
    },
    beforeAvatarUploadB(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    handleLicenseImgFile: function (file) {
      let that = this;

      let i = that.galIndex;
      let index = that.galIndexB;
      //              var windowURL = window.URL || window.webkitURL;
      //  this.imageUrl=windowURL.createObjectURL(file.raw);
      var formData = new FormData();
      formData.append("file", file.file);

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            let msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          let obj = {};

          that.orderInfo.productList[i].productImgList[index].productImg =
            res.data.data.data.path;
          that.orderInfo.productList[i].productImgList[index].productImgB =
            res.data.data.data.url;
          //  that.imageUrl=res.data.data.realPath
          //    that.imageUrlA=res.data.data.path
          that.$forceUpdate();
          loading.close();
        }
      });
    },
    beforeAvatarUpload(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    //跳转到销售单详情
    linkOrderNO(val, status) {
      let that = this;
      that.$router.push({
        path: "/creatOrder",
        query: {
          orderId: val,
          shopId: status,
        },
      });
    },
    getOrderList(dataA) {
      let that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "four") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "seven") {
        status = 5;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA.replace(/\s/g, "") : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate:
          that.deliveryStartDate && status == 3 ? that.deliveryStartDate : null,
        deliveryEndDate:
          that.deliveryEndDate && status == 3 ? that.deliveryEndDate : null,
        statementStartDate:
          that.statementStartDate && status == 4
            ? that.statementStartDate
            : null,
        statementEndDate:
          that.statementEndDate && status == 4 ? that.statementEndDate : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        addressId: that.search.addressId,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
        // storeStartDate:that.storeStartDate,
        // storeEndDate:that.storeEndDate
      };
      if (status == 2) {
        (data.storeStartDate = that.storeStartDate),
          (data.storeEndDate = that.storeEndDate);
      }
      order.getOrderList(data).then((res) => {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              val.storeDate = "";
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
                val.storeDate = mUtils
                  .formatDate(new Date(val.storeTime))
                  .substring(0, 10);
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils
                  .formatDate(new Date(val.deliveryTime))
                  .substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils
                  .formatDate(new Date(val.statementTime))
                  .substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
              if (
                val.detailList &&
                val.detailList.length > 0 &&
                val.detailList[0].productName.length > 20
              ) {
                if (val.detailList.length >= 2) {
                  val.productName =
                    val.detailList[0].productName.substring(0, 20) +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(
                    0,
                    20
                  );
                }
              } else {
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList.length >= 2
                ) {
                  val.productName =
                    val.detailList[0].productName +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
                // val.productName=val.detailList[0].productName
              }
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    getOrderListB(pageIndex, callback, pageCount) {
      let that = this;

      // const loading = this.$loading({
      //   lock: true,
      //   text: "loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // setTimeout(function () {
      //   loading.close();
      // }, 45000);
      let status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "four") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      // that.pagTotal=false
      let data = {
        // pageIndex: page,
        // pageSize: that.paginations.page_size,
        pageIndex: pageIndex,
        pageSize: pageCount,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate:
          that.deliveryStartDate && status == 3 ? that.deliveryStartDate : null,
        deliveryEndDate:
          that.deliveryEndDate && status == 3 ? that.deliveryEndDate : null,
        statementStartDate:
          that.statementStartDate && status == 4
            ? that.statementStartDate
            : null,
        statementEndDate:
          that.statementEndDate && status == 4 ? that.statementEndDate : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        addressId: that.search.addressId,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
      };
      if (status == 2) {
        (data.storeStartDate = that.storeStartDate),
          (data.storeEndDate = that.storeEndDate);
      }
      // order.getOrderList(data).then(async (res) => {
         order.exportOutCountryOrder(data).then(async (res) => {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              val.goodName =
                that.goodTypeName(val.goodType) + "-" + val.goodName;
              if (val.remark) {
                val.remark = val.remark;
              }
              if (val.userRemark) {
                val.userRemark = val.userRemark;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
              if (
                val.detailList &&
                val.detailList.length > 0 &&
                val.detailList[0].productName.length > 20
              ) {
                if (val.detailList.length >= 2) {
                  val.productName =
                    val.detailList[0].productName.substring(0, 20) +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(
                    0,
                    20
                  );
                }
              } else {
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList.length >= 2
                ) {
                  val.productName =
                    val.detailList[0].productName +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
                // val.productName=val.detailList[0].productName
              }
            });
            that.postCount++;
            await callback(
              res.data.data.list,
              res.data.data.pageCount,
              pageIndex
            );
          } else {
            that.orderMoneyB = that.orderMoneyB;
            await callback([], res.data.data.pageCount);
          }
        } else {
          callback();
          that.$message.error("导出订单列表失败");
        }
        // loading.close();
      });
    },
    changeDate(val) {},

    //  获取现在的时间
    getNowData() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log(4422,this.search.goodType)
      let param = { type: this.search.goodType || 1 };
      setTimeout(function () {
        loading.close();
      }, 5000);
      order.getNowDate(param).then(function (res) {
        if (res.data.code != 0) {
          let msg;
          msg = "获取现在的时间失败 !";
          that.$message.error(msg);
          return;
        } else {
          if (res.data && res.data.data && res.data.data.time) {
            that.newDate = res.data.data.time;
          }
          if (res.data && res.data.data && res.data.data.batchNumber) {
            that.sendDialog.remark = res.data.data.batchNumber;
          }

          // this.newDate= mUtils.formatDate( new Date())
          loading.close();
        }
      });
    },
    backA() {
      this.dialog.show = false;
      this.DataInformation = "";
    },
    //返回上一个页面
    back() {
      this.$router.go(-1); //返回上一层
    },

    filedSel() {
      let that = this;
      that.startDate = "";
      that.endDate = "";
      that.orderNOA = "";
      that.valueType = 1;
      that.getOrderList();
    },
    //导出到excel

    async exportToExcel() {
      let that = this;
      let orderName = "";
      that.orderMoneyB = [];
      that.pagTotal = false;
      that.postCount = 0;
      let pageCountt = 400;
      let columns = null;
      that.excelList = [];
      that.excelList2 = [];
      let nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
      if (that.activeName == "first") {
        columns = this.columns;
        // that.getOrderList();
      } else if (that.activeName == "second") {
        columns = this.columns;
        // that.getOrderList();
        orderName = "国内待入库" + nowTime;
      } else if (that.activeName == "third") {
        orderName = "国内入库" + nowTime;
        // that.getOrderList();
        columns = this.columns;
      } else if (that.activeName == "four") {
        orderName = "国内出库" + nowTime;
        columns = this.columns2;
      } else if (that.activeName == "7") {
        orderName = "（中心仓）已入库" + nowTime;
        columns = this.columns2;
      } else if (that.activeName == "8") {
        orderName = "（中心仓）已出库" + nowTime;
        columns = this.columns2;
      } else if (that.activeName == "9") {
        orderName = "分舵入库" + nowTime;
        columns = this.columns2;
      } else if (that.activeName == "five") {
        orderName = "已结单" + nowTime;
        columns = this.columns;
      } else if (that.activeName == "six") {
        orderName = "已取消" + nowTime;
        columns = this.columns2;
      }
      // let pageTotal = 0;

      // let pageI = that.paginations.page_size;
      if (that.paginations.total) {
        // pageTotal = that.paginations.total;
        that.pageIndex = Math.ceil(that.paginations.total / pageCountt);
        // if (pageTotal % pageI) {
        //   that.pageIndex =
        //     that.pageIndex + (pageTotal - (pageTotal % pageI)) / pageI + 1;
        // } else {
        //   that.pageIndex = that.pageIndex + Math.floor(pageTotal / pageI);
        // }
        const loading = this.$loading({
          lock: true,
          text: "loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // setTimeout(function () {
        //   loading.close();
        // }, 10000);
        that.bool = false;
        for (let i = 1; i <= that.pageIndex; i++) {
          that.pageIndexB = i;
          await that.getOrderListB(
            that.pageIndexB,
            function (val, pageCount, index) {
              that.orderMoneyB = that.orderMoneyB.concat(val);
              that.excelList[index - 1] = val;
              if (
                i == that.pageIndex &&
                that.bool == false &&
                that.postCount == that.pageIndex
              ) {
                for (let i = 0; i < that.excelList.length; i++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[i]);
                }
                mUtils.export2Excel(columns, that.excelList2, orderName);

                loading.close();
                that.bool = true;
              } else if (
                pageCount <= that.orderMoneyB.length &&
                that.bool == false
              ) {
                loading.close();
                for (let i = 0; i < that.excelList.length; i++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[i]);
                }

                mUtils.export2Excel(columns, that.excelList2, orderName);
                that.bool = true;
              }
            },
            pageCountt
          );
        }
      }
    },
    //获取出库入库时间
    getTimes(row, type) {
      if (type == 1) return mUtils.formatDate(new Date(row.expressTime), 4);
      else if (type == 2)
        return mUtils.formatDate(new Date(row.operatorTime), 4);
      else if (type == 3) return mUtils.formatDate(new Date(row.storeTime), 4);
    },
    // 提现
    withDeposit() {},
    // 交易流水
    runTab() {},
    //订单记录
    orderIn() {},
    //提现记录
    tabInformation() {
      let that = this;
    },
    onsubmit() {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      let validd;
      // that.$refs.search.validate((valid) => {
      //     validd = valid;

      //     return true
      // })

      // if(validd){
      that.onsubUpdate("3");
      loading.close();
      //  }else{
      //            that.$message.error('表单输入错误 !')
      //           loading.close();
      //           return false
      //       }
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getOrderList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getOrderList();
    },

    changeToTime(datetimes) {
      let date = new Date(datetimes);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      let h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      let m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      var str = Y + M + D + " " + h + m + s;
      return str;
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },


 // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.init();
    },

    batchChange() {
      this.init();
    },

// 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },
  },
};
</script>
<style  lang="less" scoped>
// Excel批量合箱弹窗样式
.excel-upload-container {
  .upload-area {
    margin-bottom: 20px;
    
    .upload-demo {
      width: 100%;
      
      .el-upload {
        width: 100%;
      }
      
      .el-upload-dragger {
        width: 100%;
        height: 180px;
        border: 2px dashed #d9d9d9;
        border-radius: 6px;
        background-color: #fafafa;
        text-align: center;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: border-color 0.3s;
        
        &:hover {
          border-color: #409eff;
        }
        
        .el-icon-upload {
          font-size: 67px;
          color: #c0c4cc;
          margin: 40px 0 16px;
          line-height: 50px;
        }
        
        .el-upload__text {
          color: #606266;
          font-size: 14px;
          text-align: center;
          
          em {
            color: #409eff;
            font-style: normal;
          }
        }
      }
      
      .el-upload__tip {
        font-size: 12px;
        color: #606266;
        margin-top: 7px;
        text-align: center;
      }
    }
  }
  
  .upload-progress {
    margin-top: 20px;
    
    .progress-text {
      text-align: center;
      margin-top: 10px;
      font-size: 14px;
      color: #606266;
    }
  }
}

.order_main {
  .tab_address {
    .p1 {
      line-height: 20px;
    }
  }
  .order_base {
    margin-top: 20px;
  }
  .order_detail {
    .title {
      padding: 10px 0;
      border-bottom: 1px solid #e1e1e1;
      position: relative;
      .name {
        font-size: 16px;
        font-weight: bold;
      }
      .order_add {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 14px;
        padding: 8px 15px;
      }
    }
  }
  .product_list {
    padding-top: 5px;
    .p_item {
      margin-top: 10px;
      position: relative;
      min-height: 90px;
      border-bottom: 1px solid #e1e1e1;
      padding-bottom: 10px;
      .p_num {
        font-size: 18px;
        font-weight: bold;
        width: 30px;
        text-align: center;
        padding-top: 35px;
        display: inline-block;
      }
      .p_name {
        position: absolute;
        left: 50px;
        top: 0;
        .p_input {
          width: 420px;
          margin-bottom: 10px;
        }
      }
      .p_del {
        position: absolute;
        right: 10px;
        top: 35px;
        cursor: pointer;
        .el-icon-delete {
          font-size: 20px;
          color: #409eff;
        }
      }
    }
  }
}
.financeSetA::-webkit-scrollbar {
  display: none;
}
.sign {
  font-size: 12px;
  color: #e6a23c;
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
}
.financeSetA {
  margin: 0 30px 50px 30px;
  // width: 900px;
  overflow: hidden;
  .monewt {
    // border: 1px solid rgba(121, 121, 121, 1);
    min-height: 50px;
    min-width: 900px;
  }
}
.footer {
  width: 100%;
  margin: 20px 0 50px 0;
  position: relative;

  .footer_pagination {
    position: absolute;
    right: 0;
    top: 0;
    left: 200px;
    margin-top: 0;
    text-align: right;
  }
}

.backakdia {
  background: #dcdfe6;
  line-height: 30px;
  min-height: 30px;
}
.ss {
  cursor: pointer;
  color: #409eff;
}
.navCal {
  margin-top: 10px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.ellipsis {
  // max-width: 150px;
  max-height: 20px;
  //  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisB {
  max-width: 580px;
  max-height: 20px;
  // overflow:hidden;
  white-space: nowrap;
  // text-overflow:ellipsis;
  overflow: hidden;
  // white-space: pre-wrap	;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.ellipsisBB {
  max-width: 220px;
  max-height: 20px;
  // overflow:hidden;
  white-space: nowrap;
  // text-overflow:ellipsis;
  overflow: hidden;
  // white-space: pre-wrap	;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.wel-flex {
  display: flex;
  justify-content: left;
  align-items: center;
  margin: 10px 0;
}

.wrl-hedaNa {
  margin: 10px 0;
}
.wrl-productList {
  margin: 20px 0;
}
.wrl-border {
  height: 2px;
  margin: 20px 0;
  background-color: #d7d7d7;
}
.wrl-marign {
  margin: 0 30px;
}
.wrl-flex2 {
  display: flex;
  margin: 10px 0;
  justify-content: start;
  align-items: center;
  .wrl-felx4 {
    width: 540px;
  }
  .wrl-felx44 {
    width: 170px;
  }
  .wrl-felx5 {
    max-width: 700px;
  }
  .wrl-felx6:nth-child(:first) {
    margin-left: 10px;
  }
}
.wrl-felxz {
  margin: 10px 30px;
  display: flex;
  justify-content: space-between;

  .wrl-left {
    flex: 1;
    .wrl-felxz1 {
      display: flex;
    }
  }
}
.lbl_title {
  height: 40px;
  line-height: 40px;
  &.lbl_margin {
    margin-left: 15px;
  }
}
.backgroundA {
  background-image: url("../../assets/img/u36050.svg");
  //  min-height: 80px;
  line-height: 47px;
  //  width:50px;
  //   height:50px;
  // margin: 24% 30%;
  color: white;
  background-repeat: no-repeat;
}
.avatar {
  min-height: 48px;
  width: 48px;
}
.wlr-header {
  display: flex;
  height: 30px;
  line-height: 30px;
  align-items: center;
  justify-content: space-between;
  .wlr-start {
    display: flex;
    justify-content: start;
  }
}
.inpoutTop {
  margin-top: 5px;
  width: 70px;
}
.space {
  margin: 0 5px;
}
.wrl-flex56 {
  display: flex;
  margin-right: 20px;
  justify-content: center;
  font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 40px;
  height: 40px;
}
.wrl-flex57 {
  // width: 177px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.pta {
  position: relative;
  .childe {
    position: absolute;
    right: -8px;
    top: -10px;
  }
}
.el-icon-delete {
  font-size: 20px;
}
.widthA {
  width: 48px;
}
.widthB {
  width: 150px;
}
.wrl-flex32 {
  display: flex;
  justify-content: flex-end;
  margin-top: -15px;
  .wrl-leftig {
    margin-right: 5vw;
  }
}
.backRed {
  color: #ec808d;
}
.cursor {
  cursor: pointer;
}
.red {
  color: rgb(217, 0, 27) !important;
}
.flex22 {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  height: 30px;
  align-items: center;
  .font {
    font-family: "PingFangSC-Medium", "PingFang SC Medium", "PingFang SC",
      sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    color: #555555;
    line-height: normal;
    // font-weight: bold;
  }
}
.flex4 {
  display: flex;
  margin-top: 50px;
  justify-content: center;
}
.spaceLeft {
  margin-left: 20px;
}
.lineHeight {
  line-height: 45px;
  height: 45px;
}
.showFlex {
  display: flex;
  justify-content: center;
  line-height: 44px;
  height: 44px;
}
.showFontSize {
  font-size: 18px;
  font-weight: bold;
}
.lineHeightTop {
  height: 1px;
  background: #797979;
  margin: 10px 0 20px 0;
}
</style>
<style>
.el-table th.gutter {
  display: table-cell !important;
}
.navCal .is-active {
  background-color: rgba(2, 125, 180, 1);
  color: white !important;
}
.search_lbl {
  color: #606266;
}
.inpout .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.bt .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  /* border: 1px solid #DCDFE6; */
  color: #409eff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 4px;
}
.flex22 .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #FFF;
    border: 1px solid #DCDFE6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
}
.addProdauc .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #FFF;
    border: 1px solid #DCDFE6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
}
/* .scrt{
         overflow-x:hidden;
         overflow-y:scroll
       } */
</style>



// WEBPACK FOOTER //
// orderList.vue?29a9f53b